(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(self, () => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "../../../node_modules/base64-js/index.js":
/*!************************************************!*\
  !*** ../../../node_modules/base64-js/index.js ***!
  \************************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ "../../../node_modules/buffer/index.js":
/*!*********************************************!*\
  !*** ../../../node_modules/buffer/index.js ***!
  \*********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



const base64 = __webpack_require__(/*! base64-js */ "../../../node_modules/base64-js/index.js")
const ieee754 = __webpack_require__(/*! ieee754 */ "../../../node_modules/ieee754/index.js")
const customInspectSymbol =
  (typeof Symbol === 'function' && typeof Symbol['for'] === 'function') // eslint-disable-line dot-notation
    ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
    : null

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

const K_MAX_LENGTH = 0x7fffffff
exports.kMaxLength = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    const arr = new Uint8Array(1)
    const proto = { foo: function () { return 42 } }
    Object.setPrototypeOf(proto, Uint8Array.prototype)
    Object.setPrototypeOf(arr, proto)
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  const buf = new Uint8Array(length)
  Object.setPrototypeOf(buf, Buffer.prototype)
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayView(value)
  }

  if (value == null) {
    throw new TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof SharedArrayBuffer !== 'undefined' &&
      (isInstance(value, SharedArrayBuffer) ||
      (value && isInstance(value.buffer, SharedArrayBuffer)))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  const valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  const b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length)
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype)
Object.setPrototypeOf(Buffer, Uint8Array)

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  const length = byteLength(string, encoding) | 0
  let buf = createBuffer(length)

  const actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  const length = array.length < 0 ? 0 : checked(array.length) | 0
  const buf = createBuffer(length)
  for (let i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayView (arrayView) {
  if (isInstance(arrayView, Uint8Array)) {
    const copy = new Uint8Array(arrayView)
    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength)
  }
  return fromArrayLike(arrayView)
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  let buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(buf, Buffer.prototype)

  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    const len = checked(obj.length) | 0
    const buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  let x = a.length
  let y = b.length

  for (let i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  let i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  const buffer = Buffer.allocUnsafe(length)
  let pos = 0
  for (i = 0; i < list.length; ++i) {
    let buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      if (pos + buf.length > buffer.length) {
        if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf)
        buf.copy(buffer, pos)
      } else {
        Uint8Array.prototype.set.call(
          buffer,
          buf,
          pos
        )
      }
    } else if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    } else {
      buf.copy(buffer, pos)
    }
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  const len = string.length
  const mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  let loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  let loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  const i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  const len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (let i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  const len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (let i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  const len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (let i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  const length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  let str = ''
  const max = exports.INSPECT_MAX_BYTES
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}
if (customInspectSymbol) {
  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  let x = thisEnd - thisStart
  let y = end - start
  const len = Math.min(x, y)

  const thisCopy = this.slice(thisStart, thisEnd)
  const targetCopy = target.slice(start, end)

  for (let i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  let indexSize = 1
  let arrLength = arr.length
  let valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  let i
  if (dir) {
    let foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      let found = true
      for (let j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  const remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  const strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  let i
  for (i = 0; i < length; ++i) {
    const parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  const remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  let loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
      case 'latin1':
      case 'binary':
        return asciiWrite(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  const res = []

  let i = start
  while (i < end) {
    const firstByte = buf[i]
    let codePoint = null
    let bytesPerSequence = (firstByte > 0xEF)
      ? 4
      : (firstByte > 0xDF)
          ? 3
          : (firstByte > 0xBF)
              ? 2
              : 1

    if (i + bytesPerSequence <= end) {
      let secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  const len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  let res = ''
  let i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  let ret = ''
  end = Math.min(buf.length, end)

  for (let i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  let ret = ''
  end = Math.min(buf.length, end)

  for (let i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  const len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  let out = ''
  for (let i = start; i < end; ++i) {
    out += hexSliceLookupTable[buf[i]]
  }
  return out
}

function utf16leSlice (buf, start, end) {
  const bytes = buf.slice(start, end)
  let res = ''
  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
  for (let i = 0; i < bytes.length - 1; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  const len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  const newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(newBuf, Buffer.prototype)

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUintLE =
Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  let val = this[offset]
  let mul = 1
  let i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUintBE =
Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  let val = this[offset + --byteLength]
  let mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUint8 =
Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUint16LE =
Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUint16BE =
Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUint32LE =
Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUint32BE =
Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const lo = first +
    this[++offset] * 2 ** 8 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 24

  const hi = this[++offset] +
    this[++offset] * 2 ** 8 +
    this[++offset] * 2 ** 16 +
    last * 2 ** 24

  return BigInt(lo) + (BigInt(hi) << BigInt(32))
})

Buffer.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const hi = first * 2 ** 24 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    this[++offset]

  const lo = this[++offset] * 2 ** 24 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    last

  return (BigInt(hi) << BigInt(32)) + BigInt(lo)
})

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  let val = this[offset]
  let mul = 1
  let i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  let i = byteLength
  let mul = 1
  let val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  const val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  const val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const val = this[offset + 4] +
    this[offset + 5] * 2 ** 8 +
    this[offset + 6] * 2 ** 16 +
    (last << 24) // Overflow

  return (BigInt(val) << BigInt(32)) +
    BigInt(first +
    this[++offset] * 2 ** 8 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 24)
})

Buffer.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    this[++offset]

  return (BigInt(val) << BigInt(32)) +
    BigInt(this[++offset] * 2 ** 24 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    last)
})

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUintLE =
Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    const maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  let mul = 1
  let i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUintBE =
Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    const maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  let i = byteLength - 1
  let mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUint8 =
Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUint16LE =
Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUint16BE =
Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUint32LE =
Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUint32BE =
Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function wrtBigUInt64LE (buf, value, offset, min, max) {
  checkIntBI(value, min, max, buf, offset, 7)

  let lo = Number(value & BigInt(0xffffffff))
  buf[offset++] = lo
  lo = lo >> 8
  buf[offset++] = lo
  lo = lo >> 8
  buf[offset++] = lo
  lo = lo >> 8
  buf[offset++] = lo
  let hi = Number(value >> BigInt(32) & BigInt(0xffffffff))
  buf[offset++] = hi
  hi = hi >> 8
  buf[offset++] = hi
  hi = hi >> 8
  buf[offset++] = hi
  hi = hi >> 8
  buf[offset++] = hi
  return offset
}

function wrtBigUInt64BE (buf, value, offset, min, max) {
  checkIntBI(value, min, max, buf, offset, 7)

  let lo = Number(value & BigInt(0xffffffff))
  buf[offset + 7] = lo
  lo = lo >> 8
  buf[offset + 6] = lo
  lo = lo >> 8
  buf[offset + 5] = lo
  lo = lo >> 8
  buf[offset + 4] = lo
  let hi = Number(value >> BigInt(32) & BigInt(0xffffffff))
  buf[offset + 3] = hi
  hi = hi >> 8
  buf[offset + 2] = hi
  hi = hi >> 8
  buf[offset + 1] = hi
  hi = hi >> 8
  buf[offset] = hi
  return offset + 8
}

Buffer.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE (value, offset = 0) {
  return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'))
})

Buffer.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE (value, offset = 0) {
  return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'))
})

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    const limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  let i = 0
  let mul = 1
  let sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    const limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  let i = byteLength - 1
  let mul = 1
  let sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE (value, offset = 0) {
  return wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'))
})

Buffer.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE (value, offset = 0) {
  return wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'))
})

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  const len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      const code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  } else if (typeof val === 'boolean') {
    val = Number(val)
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  let i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    const bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    const len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// CUSTOM ERRORS
// =============

// Simplified versions from Node, changed for Buffer-only usage
const errors = {}
function E (sym, getMessage, Base) {
  errors[sym] = class NodeError extends Base {
    constructor () {
      super()

      Object.defineProperty(this, 'message', {
        value: getMessage.apply(this, arguments),
        writable: true,
        configurable: true
      })

      // Add the error code to the name to include it in the stack trace.
      this.name = `${this.name} [${sym}]`
      // Access the stack to generate the error message including the error code
      // from the name.
      this.stack // eslint-disable-line no-unused-expressions
      // Reset the name to the actual name.
      delete this.name
    }

    get code () {
      return sym
    }

    set code (value) {
      Object.defineProperty(this, 'code', {
        configurable: true,
        enumerable: true,
        value,
        writable: true
      })
    }

    toString () {
      return `${this.name} [${sym}]: ${this.message}`
    }
  }
}

E('ERR_BUFFER_OUT_OF_BOUNDS',
  function (name) {
    if (name) {
      return `${name} is outside of buffer bounds`
    }

    return 'Attempt to access memory outside buffer bounds'
  }, RangeError)
E('ERR_INVALID_ARG_TYPE',
  function (name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`
  }, TypeError)
E('ERR_OUT_OF_RANGE',
  function (str, range, input) {
    let msg = `The value of "${str}" is out of range.`
    let received = input
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) {
      received = addNumericalSeparator(String(input))
    } else if (typeof input === 'bigint') {
      received = String(input)
      if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) {
        received = addNumericalSeparator(received)
      }
      received += 'n'
    }
    msg += ` It must be ${range}. Received ${received}`
    return msg
  }, RangeError)

function addNumericalSeparator (val) {
  let res = ''
  let i = val.length
  const start = val[0] === '-' ? 1 : 0
  for (; i >= start + 4; i -= 3) {
    res = `_${val.slice(i - 3, i)}${res}`
  }
  return `${val.slice(0, i)}${res}`
}

// CHECK FUNCTIONS
// ===============

function checkBounds (buf, offset, byteLength) {
  validateNumber(offset, 'offset')
  if (buf[offset] === undefined || buf[offset + byteLength] === undefined) {
    boundsError(offset, buf.length - (byteLength + 1))
  }
}

function checkIntBI (value, min, max, buf, offset, byteLength) {
  if (value > max || value < min) {
    const n = typeof min === 'bigint' ? 'n' : ''
    let range
    if (byteLength > 3) {
      if (min === 0 || min === BigInt(0)) {
        range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`
      } else {
        range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` +
                `${(byteLength + 1) * 8 - 1}${n}`
      }
    } else {
      range = `>= ${min}${n} and <= ${max}${n}`
    }
    throw new errors.ERR_OUT_OF_RANGE('value', range, value)
  }
  checkBounds(buf, offset, byteLength)
}

function validateNumber (value, name) {
  if (typeof value !== 'number') {
    throw new errors.ERR_INVALID_ARG_TYPE(name, 'number', value)
  }
}

function boundsError (value, length, type) {
  if (Math.floor(value) !== value) {
    validateNumber(value, type)
    throw new errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value)
  }

  if (length < 0) {
    throw new errors.ERR_BUFFER_OUT_OF_BOUNDS()
  }

  throw new errors.ERR_OUT_OF_RANGE(type || 'offset',
                                    `>= ${type ? 1 : 0} and <= ${length}`,
                                    value)
}

// HELPER FUNCTIONS
// ================

const INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  let codePoint
  const length = string.length
  let leadSurrogate = null
  const bytes = []

  for (let i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  const byteArray = []
  for (let i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  let c, hi, lo
  const byteArray = []
  for (let i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  let i
  for (i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const hexSliceLookupTable = (function () {
  const alphabet = '0123456789abcdef'
  const table = new Array(256)
  for (let i = 0; i < 16; ++i) {
    const i16 = i * 16
    for (let j = 0; j < 16; ++j) {
      table[i16 + j] = alphabet[i] + alphabet[j]
    }
  }
  return table
})()

// Return not function with Error if BigInt not supported
function defineBigIntMethod (fn) {
  return typeof BigInt === 'undefined' ? BufferBigIntNotDefined : fn
}

function BufferBigIntNotDefined () {
  throw new Error('BigInt not supported')
}


/***/ }),

/***/ "../../../node_modules/ieee754/index.js":
/*!**********************************************!*\
  !*** ../../../node_modules/ieee754/index.js ***!
  \**********************************************/
/***/ ((__unused_webpack_module, exports) => {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ "./src/auth/auth-utils.ts":
/*!********************************!*\
  !*** ./src/auth/auth-utils.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AUTH_UTILS: () => (/* binding */ AUTH_UTILS)
/* harmony export */ });
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @uuip/unified-ui-platform-sdk */ "@uuip/unified-ui-platform-sdk");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__);
/* eslint-disable @typescript-eslint/no-explicit-any */

class AuthUtils {
    removeQueryParams() {
        const { origin, pathname } = window.location;
        window.history.replaceState(null, "", origin + pathname);
    }
    getParameterByName(name) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(name);
    }
    loginPopup(url) {
        return new Promise((resolve, reject) => {
            const options = this.popupCenter(500, 600);
            const popup = window.open(url, "", options);
            const interval = window.setInterval(() => {
                if (this.isPopupClosed(popup)) {
                    window.authPopupRedirectHook = undefined;
                    clearInterval(interval);
                    reject(new _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.Err.Message("UUIP.OAuth.loginPopup", "Popup closed by user"));
                }
            }, 1000);
            window.authPopupRedirectHook = (code, error) => {
                window.authPopupRedirectHook = undefined;
                clearInterval(interval);
                if (error) {
                    reject(new _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.Err.Message("UUIP.OAuth.loginPopup", error));
                }
                else {
                    resolve(code);
                }
            };
        });
    }
    // ----------------------------------------
    popupCenter(w, h) {
        const elem = document.documentElement;
        const width = window.innerWidth ? window.innerWidth : elem.clientWidth ? elem.clientWidth : screen.width;
        const height = window.innerHeight ? window.innerHeight : elem.clientHeight ? elem.clientHeight : screen.height;
        const left = width / 2 - w / 2 + window.screenLeft;
        const top = height / 2 - h / 2 + window.screenTop;
        return "width=" + w + ", height=" + h + ", top=" + top + ", left=" + left;
    }
    isPopupClosed(popup) {
        return !popup || typeof popup.closed == "undefined" || popup.closed;
    }
}
const AUTH_UTILS = new AuthUtils();


/***/ }),

/***/ "./src/auth/auth.ts":
/*!**************************!*\
  !*** ./src/auth/auth.ts ***!
  \**************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   OAuth: () => (/* binding */ OAuth)
/* harmony export */ });
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @uuip/unified-ui-platform-sdk */ "@uuip/unified-ui-platform-sdk");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! axios */ "axios");
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! qs */ "qs");
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../sdk */ "./src/sdk.ts");
/* harmony import */ var _auth_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./auth-utils */ "./src/auth/auth-utils.ts");
/* provided dependency */ var Buffer = __webpack_require__(/*! buffer */ "../../../node_modules/buffer/index.js")["Buffer"];
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};





const TOKEN_KEY = "uuip-auth-token";
const CLUSTER_ID_KEY = "clusterId";
const CI_CONFIG_KEY = "ci-config";
var OAuth;
(function (OAuth) {
    class Service {
        constructor(config) {
            this.config = config;
            const { signal, send } = _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.Signal.create.withData();
            this.tokenChange = signal;
            this.send = send;
            const refreshTokenFail = _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.Signal.create.empty();
            this.onRefreshingTokenFail = refreshTokenFail.signal;
            this.onRefreshingTokenFailSend = refreshTokenFail.send;
        }
        getToken() {
            return __awaiter(this, void 0, void 0, function* () {
                const cluster = _auth_utils__WEBPACK_IMPORTED_MODULE_4__.AUTH_UTILS.getParameterByName("ciClusterId");
                if (cluster) {
                    _auth_utils__WEBPACK_IMPORTED_MODULE_4__.AUTH_UTILS.removeQueryParams();
                    yield this.fetchClusterDetails(this.config, { clusterId: cluster });
                    this.login();
                    return null;
                }
                const code = _auth_utils__WEBPACK_IMPORTED_MODULE_4__.AUTH_UTILS.getParameterByName("code");
                if (code) {
                    _auth_utils__WEBPACK_IMPORTED_MODULE_4__.AUTH_UTILS.removeQueryParams();
                    let isPopup = false;
                    try {
                        isPopup = window.opener && window.opener.authPopupRedirectHook;
                        // eslint-disable-next-line sonarjs/no-ignored-exceptions
                    }
                    catch (error) {
                        _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.warn("Can't access 'window.opener'");
                    }
                    if (isPopup) {
                        window.opener.authPopupRedirectHook(code);
                        window.close();
                        yield new Promise((r) => (0,_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.setTimeout)(() => r, 4000));
                        return null;
                    }
                    else {
                        yield this.fetchClusterDetails(this.config, { code });
                        const t = yield this.requestToken({ code });
                        if (t) {
                            this.beginTokenRotation(t);
                            return t.token;
                        }
                        else {
                            return null;
                        }
                    }
                }
                // check error
                const error = _auth_utils__WEBPACK_IMPORTED_MODULE_4__.AUTH_UTILS.getParameterByName("error");
                if (error) {
                    let isPopup = false;
                    try {
                        isPopup = window.opener && window.opener.authPopupRedirectHook;
                        // eslint-disable-next-line sonarjs/no-ignored-exceptions
                    }
                    catch (windowOpenerError) {
                        _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.warn("Can't access 'window.opener'");
                    }
                    if (isPopup) {
                        window.opener.authPopupRedirectHook("", error);
                        window.close();
                        return null;
                    }
                    else {
                        _auth_utils__WEBPACK_IMPORTED_MODULE_4__.AUTH_UTILS.removeQueryParams();
                        throw new _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.Err.Message("UUIP.OAuth.getToken", error);
                    }
                }
                // check localStorage
                const cache = localStorage.getItem(TOKEN_KEY);
                const ci_config = localStorage.getItem(CI_CONFIG_KEY);
                if (ci_config && ci_config !== "{}") {
                    const c = JSON.parse(ci_config);
                    this.config.identityUrl = c.identityUrl;
                    this.config.idbrokerUrl = c.idbrokerUrl;
                    _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.info("[FetchToken] event=getToken | Taking FLS identity URL from cache");
                }
                if (cache && cache !== "{}") {
                    const t = JSON.parse(cache);
                    const expiary = this.millisecondsBeforeExpiary(t);
                    // if (checkIfValid) {
                    //   const res = await this.validateAccessToken(t.token.access_token);
                    //   if (!res.isValid) {
                    //     localStorage.removeItem(TOKEN_KEY);
                    //     return null;
                    //   }
                    // }
                    if (expiary.ofToken > 0) {
                        this.beginTokenRotation(t);
                        return t.token;
                    }
                    else if (expiary.ofRefreshToken > 0) {
                        // should I check requestToken before ???
                        const tRefresh = yield this.requestToken({ refresh: t.token.refresh_token });
                        if (tRefresh) {
                            this.beginTokenRotation(tRefresh);
                            return tRefresh.token;
                        }
                        else {
                            return null;
                        }
                    }
                    else {
                        localStorage.removeItem(TOKEN_KEY);
                    }
                }
                return null;
            });
        }
        login() {
            localStorage.removeItem(TOKEN_KEY);
            const url = this.generateLoginUrl();
            window.location.replace(url);
        }
        loginPopup() {
            return __awaiter(this, void 0, void 0, function* () {
                localStorage.removeItem(TOKEN_KEY);
                const url = this.generateLoginUrl();
                const code = yield _auth_utils__WEBPACK_IMPORTED_MODULE_4__.AUTH_UTILS.loginPopup(url);
                const t = yield this.requestToken({ code });
                if (t) {
                    this.beginTokenRotation(t);
                    return t.token;
                }
                else {
                    return null;
                }
            });
        }
        logout(accessToken) {
            return __awaiter(this, void 0, void 0, function* () {
                localStorage.removeItem(TOKEN_KEY);
                localStorage.removeItem(CLUSTER_ID_KEY);
                localStorage.removeItem(CI_CONFIG_KEY);
                // const res = await this.validateAccessToken(accessToken);
                // if (res.isValid) {
                const query = qs__WEBPACK_IMPORTED_MODULE_2___default().stringify({
                    token: accessToken,
                    goto: window.location.origin
                });
                window.location.replace(`${this.config.idbrokerUrl}/idb/oauth2/v1/logout?${query}`);
                // } else {
                //   window.location.replace(window.location.origin);
                // }
            });
        }
        // ------------------------------
        requestToken(p) {
            return __awaiter(this, void 0, void 0, function* () {
                _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.info("[FetchToken] event=getToken | Fetching of token started");
                return new Promise((resolve) => {
                    const req = axios__WEBPACK_IMPORTED_MODULE_1___default().CancelToken.source();
                    const timeout = window.setTimeout(() => req.cancel(), 15000);
                    axios__WEBPACK_IMPORTED_MODULE_1___default().request({
                        url: `${this.config.idbrokerUrl}/idb/oauth2/v1/access_token`,
                        method: "post",
                        cancelToken: req.token,
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded",
                            Authorization: this.basicAuthHeader
                        },
                        params: "code" in p
                            ? {
                                grant_type: "authorization_code",
                                redirect_uri: this.redirectUri,
                                code: p.code,
                                self_contained_token: this.config.useSelfContained
                            }
                            : {
                                grant_type: "refresh_token",
                                refresh_token: p.refresh,
                                self_contained_token: this.config.useSelfContained
                            }
                    })
                        .then((res) => {
                        const token = {
                            access_token: res.data.access_token,
                            expires_in: res.data.expires_in,
                            refresh_token: res.data.refresh_token,
                            refresh_token_expires_in: res.data.refresh_token_expires_in
                        };
                        const cache = { token, timestamp: Date.now() };
                        localStorage.setItem(TOKEN_KEY, JSON.stringify(cache));
                        _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.info("[FetchToken] event=requestToken | Token fetched and saved to cache");
                        this.send(cache);
                        (0,_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.clearTimeout)(timeout);
                        resolve(cache);
                    })
                        .catch((err) => {
                        var _a;
                        if (axios__WEBPACK_IMPORTED_MODULE_1___default().isCancel(err)) {
                            _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.error("[FetchToken] event=requestToken | Token Request error: timeout");
                        }
                        else {
                            const errorData = ((_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data) || (err === null || err === void 0 ? void 0 : err.message);
                            _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.error(`[FetchToken] event=requestToken | Token Request error: ${JSON.stringify(errorData)}`);
                        }
                        (0,_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.clearTimeout)(timeout);
                        resolve(null);
                    });
                });
            });
        }
        getTokenCacheFromLS() {
            const cache = localStorage.getItem(TOKEN_KEY);
            if (cache && cache !== "{}") {
                return JSON.parse(cache);
            }
            return null;
        }
        isTokenValid() {
            const tokenCache = this.getTokenCacheFromLS();
            if (tokenCache) {
                const expiary = this.millisecondsBeforeExpiary(tokenCache);
                return expiary.ofToken > 0;
            }
            return false;
        }
        logAndSendFailure(message) {
            _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.error(message);
            this.onRefreshingTokenFailSend();
        }
        isRefreshTokenExpired(tFromCache) {
            const expiry = this.millisecondsBeforeExpiary(tFromCache);
            return expiry.ofRefreshToken <= 0;
        }
        handleTokenRefresh() {
            return __awaiter(this, void 0, void 0, function* () {
                const tokenCache = this.getTokenCacheFromLS();
                if (!tokenCache) {
                    this.logAndSendFailure("[FetchToken] event=TokenRefresh |Can't refresh OAuth token. No Token in LocalStorage.");
                    return null;
                }
                if (this.isRefreshTokenExpired(tokenCache)) {
                    this.logAndSendFailure("[FetchToken] event=TokenRefresh | Can't refresh OAuth token. refresh_token expired.");
                    return null;
                }
                const tRefresh = yield this.requestToken({ refresh: tokenCache.token.refresh_token });
                if (!tRefresh) {
                    this.logAndSendFailure("[FetchToken] event=TokenRefresh | Can't refresh OAuth token. requestToken function fail.");
                    return null;
                }
                this.beginTokenRotation(tRefresh);
                return tRefresh;
            });
        }
        getNewToken() {
            return __awaiter(this, void 0, void 0, function* () {
                const newToken = yield this.handleTokenRefresh();
                return newToken;
            });
        }
        beginTokenRotation(t) {
            if (this.timeout !== undefined) {
                (0,_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.clearTimeout)(this.timeout);
                this.timeout = undefined;
            }
            // 75% of expiry time to be taken for offset
            const time = this.millisecondsBeforeExpiary(t).ofToken - t.token.expires_in * 1000 * 0.25;
            this.timeout = (0,_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.setTimeout)(() => __awaiter(this, void 0, void 0, function* () {
                this.timeout = undefined;
                this.handleTokenRefresh();
            }), time < 0 ? 0 : time);
        }
        fetchClusterDetails(config, p) {
            return __awaiter(this, void 0, void 0, function* () {
                const clusterId = "clusterId" in p ? p.clusterId : p.code.split("_")[1];
                localStorage.setItem(CLUSTER_ID_KEY, clusterId);
                const fls = yield axios__WEBPACK_IMPORTED_MODULE_1___default().request({
                    url: `${config.idbrokerUrl}/idb/oauth2/v1/access_token`,
                    method: "POST",
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        Authorization: this.basicAuthHeader
                    },
                    params: {
                        grant_type: "client_credentials",
                        scope: "Identity:SCIM",
                        self_contained_token: true
                    }
                });
                const res = yield axios__WEBPACK_IMPORTED_MODULE_1___default().request({
                    url: `${config.flsUrl}/api/v1/Clusters/${clusterId}`,
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${fls.data.access_token}`,
                        "Cache-Control": "no-cache",
                        Pragma: "no-cache"
                    }
                });
                this.config.idbrokerUrl = res.data.clusterLocationEndpoints.idBrokerUrl;
                this.config.identityUrl = res.data.clusterLocationEndpoints.identityUrl;
                localStorage.setItem(CI_CONFIG_KEY, JSON.stringify({ idbrokerUrl: this.config.idbrokerUrl, identityUrl: this.config.identityUrl }));
            });
        }
        generateLoginUrl() {
            const query = qs__WEBPACK_IMPORTED_MODULE_2___default().stringify({
                response_type: "code",
                client_id: this.config.clientId,
                scope: this.config.scopes,
                redirect_uri: this.redirectUri
            });
            return `${this.config.idbrokerUrl}/idb/oauth2/v1/authorize?${query}`;
        }
        get redirectUri() {
            return this.config.redirectUri ? this.config.redirectUri : `${window.location.origin}${window.location.pathname}`;
        }
        get basicAuthHeader() {
            // eslint-disable-next-line sonarjs/no-nested-template-literals
            return `Basic ${Buffer.from(`${this.config.clientId}:${this.config.clientSecret}`).toString("base64")}`;
        }
        millisecondsBeforeExpiary(t) {
            const passed = Date.now() - t.timestamp;
            return {
                ofToken: t.token.expires_in * 1000 - passed,
                ofRefreshToken: t.token.refresh_token_expires_in * 1000 - passed
            };
        }
    }
    OAuth.Service = Service;
})(OAuth || (OAuth = {}));


/***/ }),

/***/ "./src/identity/identity.ts":
/*!**********************************!*\
  !*** ./src/identity/identity.ts ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CI: () => (/* binding */ CI)
/* harmony export */ });
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @uuip/unified-ui-platform-sdk */ "@uuip/unified-ui-platform-sdk");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__);
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

var CI;
(function (CI) {
    class Service {
        constructor(config) {
            this.http = (0,_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.createHttp)(config.accessToken);
            this.host = config.identityUrl;
        }
        getUserMe() {
            return __awaiter(this, void 0, void 0, function* () {
                const url = `${this.host}/identity/scim/v1/Users/me`;
                const res = yield this.http.get(url);
                return res.data;
            });
        }
    }
    CI.Service = Service;
})(CI || (CI = {}));


/***/ }),

/***/ "./src/router/RouterLink.ts":
/*!**********************************!*\
  !*** ./src/router/RouterLink.ts ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   RouterLink: () => (/* binding */ RouterLink)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./router */ "./src/router/router.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};


var RouterLink;
(function (RouterLink) {
    let Element = class Element extends lit_element__WEBPACK_IMPORTED_MODULE_0__.LitElement {
        constructor() {
            super(...arguments);
            this.href = "";
        }
        handleClick(e) {
            return __awaiter(this, void 0, void 0, function* () {
                this.onClick && this.onClick(e);
                e.preventDefault();
                yield _router__WEBPACK_IMPORTED_MODULE_1__.router.navigatePathUrl(this.href);
                // above strings are encapsulated in clickHandler
                // router.page.clickHandler(e);
            });
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.html) `
        <a href="${this.href}" @click="${(e) => this.handleClick(e)}" part="a">
          <slot></slot>
        </a>
      `;
        }
        static get styles() {
            return [
                (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css) `
          :host {
            display: inline;
          }
        `
            ];
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: String })
    ], Element.prototype, "href", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ attribute: false })
    ], Element.prototype, "onClick", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.customElement)("router-link")
    ], Element);
    RouterLink.Element = Element;
})(RouterLink || (RouterLink = {}));


/***/ }),

/***/ "./src/router/RouterView.ts":
/*!**********************************!*\
  !*** ./src/router/RouterView.ts ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   RouterView: () => (/* binding */ RouterView)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var node_html_parser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! node-html-parser */ "node-html-parser");
/* harmony import */ var node_html_parser__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(node_html_parser__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var node_html_parser_dist_nodes_type__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! node-html-parser/dist/nodes/type */ "node-html-parser/dist/nodes/type");
/* harmony import */ var node_html_parser_dist_nodes_type__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(node_html_parser_dist_nodes_type__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./index */ "./src/router/index.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../sdk */ "./src/sdk.ts");
/* harmony import */ var _directives__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./directives */ "./src/router/directives.ts");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_6__);
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



/**
 * WARNING! This import "./index" - to prevent webpack treeshake on dev:watch mode
 * DO NOT REMOVE!
 */





const getAdoptedStyles = (styles) => {
    if (!styles) {
        return null;
    }
    return (!Array.isArray(styles) ? [styles] : styles).map((s) => s.styleSheet);
};
var RouterView;
(function (RouterView) {
    class Block {
        static validateTemplateResult(templateResult) {
            const res = (0,node_html_parser__WEBPACK_IMPORTED_MODULE_1__.parse)(templateResult.getTemplateElement().innerHTML);
            const elNodes = res.childNodes
                .filter((node) => node.nodeType === (node_html_parser_dist_nodes_type__WEBPACK_IMPORTED_MODULE_2___default().ELEMENT_NODE))
                .map((e) => e);
            if (!elNodes || elNodes.length !== 1) {
                throw new Error("Route view block must have one root Node");
            }
            return templateResult;
        }
        constructor({ template, styles }) {
            this._adoptedStyles = null;
            this.template = Block.validateTemplateResult(template);
            this._styles = styles || (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css) ``;
            this._adoptedStyles = getAdoptedStyles(this._styles);
        }
        get styles() {
            return this._styles;
        }
        get adoptedStyles() {
            return this._adoptedStyles;
        }
    }
    RouterView.Block = Block;
    class BlocksMap {
        // Supporting blocksMaps combine
        constructor(...blocksMapArgs) {
            this._adoptedStyles = null;
            const addToStylesArray = (stylesArray, s) => {
                if (s) {
                    Array.isArray(s) ? s.forEach((_s) => addToStylesArray(stylesArray, _s)) : stylesArray.push(s);
                }
            };
            const isInstanceBlocksMapArg = (arg) => {
                return arg instanceof BlocksMap;
            };
            const isFactoryBlocksMapArg = (arg) => {
                return typeof arg === "function";
            };
            const isParamsBlocksMapArg = (arg) => {
                return arg && (arg.blocks || arg.styles);
            };
            const getBlocksMapFromArg = (arg) => {
                // Instance
                if (isInstanceBlocksMapArg(arg)) {
                    return arg;
                }
                // Factory
                else if (isFactoryBlocksMapArg(arg)) {
                    return arg();
                }
                // Params
                else if (isParamsBlocksMapArg(arg)) {
                    return new BlocksMap(arg);
                }
                else {
                    _sdk__WEBPACK_IMPORTED_MODULE_4__.logger.error("Block arg is not recognized...");
                    return null;
                }
            };
            // Supporting blocksMaps combine
            const { blocks, styles } = blocksMapArgs.length > 1
                ? (() => {
                    const { blocks, blocksMapOnlyStyles } = blocksMapArgs.reduce((acc, arg, _idx) => {
                        const blocksMap = getBlocksMapFromArg(arg);
                        if (blocksMap) {
                            blocksMap.blocksWrappersCollection.forEach((bw) => {
                                acc.blocks[bw.id] = bw.block;
                                const _s = [];
                                addToStylesArray(_s, bw.block.styles);
                                acc.blocksStylesMap[bw.id] = _s;
                            });
                            addToStylesArray(acc.blocksMapOnlyStyles, blocksMap.blocksMapOnlyStyles);
                        }
                        return acc;
                    }, {
                        blocks: {},
                        blocksStylesMap: {},
                        blocksMapOnlyStyles: []
                    });
                    return {
                        blocks,
                        styles: blocksMapOnlyStyles
                    };
                })()
                : isParamsBlocksMapArg(blocksMapArgs[0])
                    ? blocksMapArgs[0]
                    : (() => {
                        const blocksMap = getBlocksMapFromArg(blocksMapArgs[0]);
                        return {
                            blocks: blocksMap === null || blocksMap === void 0 ? void 0 : blocksMap.blocksWrappersCollection.reduce((acc, bw) => {
                                acc[bw.id] = bw.block;
                                return acc;
                            }, {}),
                            styles: blocksMap === null || blocksMap === void 0 ? void 0 : blocksMap.styles
                        };
                    })();
            // Self instance
            this._blocksMap = blocks || {};
            this._blocksWrappersCollection = Object.keys(this._blocksMap).map((k) => ({
                id: k,
                block: this._blocksMap[k]
            }));
            const _styles = [];
            const _blocksMapOnlyStyles = [];
            const _blocksOnlyStyles = [];
            addToStylesArray(_blocksMapOnlyStyles, styles || (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css) ``);
            this._blocksMapOnlyStyles = _blocksMapOnlyStyles;
            this._blocksWrappersCollection.forEach((bw) => {
                addToStylesArray(_blocksOnlyStyles, bw.block.styles);
            });
            this._blocksOnlyStyles = _blocksOnlyStyles;
            addToStylesArray(_styles, _blocksMapOnlyStyles);
            addToStylesArray(_styles, _blocksOnlyStyles);
            this._styles = _styles;
            this._adoptedStyles = getAdoptedStyles(_styles);
        }
        // ( manro ) NOTE There is no difference of sequence -> all theses blocks arranged by css grid:
        get blocksWrappersCollection() {
            return this._blocksWrappersCollection;
        }
        get blocksOnlyStyles() {
            return this._blocksOnlyStyles;
        }
        get blocksMapOnlyStyles() {
            return this._blocksMapOnlyStyles;
        }
        // All Styles (blockMap + blocks)
        get styles() {
            return this._styles;
        }
        get adoptedStyles() {
            return this._adoptedStyles;
        }
    }
    RouterView.BlocksMap = BlocksMap;
    RouterView.Noop = () => new _index__WEBPACK_IMPORTED_MODULE_3__.Router.RouterView.BlocksMap({
        styles: [(0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css) ``]
    });
    // eslint-disable-next-line no-inner-declarations
    function withRouterViewElement(baseElement) {
        return class extends baseElement {
            get isShimmedAdoptedStylesRequired() {
                // if ShadowRoot polyfilled or just supports adopting styled - we don't need work with shimmed styles nodes
                return !lit_element__WEBPACK_IMPORTED_MODULE_0__.supportsAdoptingStyleSheets;
            }
            // After new styles apply  this calling to remove "old" shimmed styles nodes (if exists)
            cleanupShimmedAdoptedStylesNodes() {
                this.shimmedAdoptedStylesNodes.forEach((n) => this.renderRoot.removeChild(n));
                this.shimmedAdoptedStylesNodes.length = 0;
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            constructor(...args) {
                super(args);
                this.shimmedAdoptedStylesNodes = [];
                // Remember Shimmed (For FF, Safari) added into DOM styles
                this.mutationObserver = null;
                if (this.isShimmedAdoptedStylesRequired) {
                    this.mutationObserver = new MutationObserver((mutations) => {
                        mutations.forEach((mutation) => {
                            // eslint-disable-next-line sonarjs/no-nested-functions
                            mutation.addedNodes.forEach((addedNode) => {
                                if (addedNode.nodeName.toLowerCase() === "style") {
                                    this.shimmedAdoptedStylesNodes.push(addedNode);
                                }
                            });
                        });
                    });
                }
            }
            connectedCallback() {
                super.connectedCallback();
                if (this.isShimmedAdoptedStylesRequired) {
                    this.mutationObserver.observe(this.renderRoot, { childList: true, subtree: true });
                }
            }
            disconnectedCallback() {
                super.disconnectedCallback();
                if (this.isShimmedAdoptedStylesRequired) {
                    this.mutationObserver.disconnect();
                }
            }
            adoptRouteViewStyles(routeStyles) {
                if (this.isShimmedAdoptedStylesRequired) {
                    // To Prepare shim - need to call before also
                    this.adoptStyles();
                    // Cleanup shimmed (inserted into DOM) nodes
                    this.cleanupShimmedAdoptedStylesNodes();
                }
                // @ts-expect-error Legacy code
                const staticStyles = this.constructor.styles;
                // @ts-expect-error Legacy code
                this.constructor.privateStyles = [
                    ...(staticStyles ? (!Array.isArray(staticStyles) ? [staticStyles] : staticStyles) : []),
                    ...(routeStyles ? (!Array.isArray(routeStyles) ? [routeStyles] : routeStyles) : [])
                ];
                this.adoptStyles();
            }
            // Under the hood LitElement is using private _styles property to adoptStyles()
            static set privateStyles(val) {
                // @ts-expect-error Legacy code
                this["_styles"] = val;
            }
        };
    }
    RouterView.withRouterViewElement = withRouterViewElement;
    // Note: router-view kind of singleton component due to static styles in LitElement
    let Element = class Element extends withRouterViewElement(lit_element__WEBPACK_IMPORTED_MODULE_0__.LitElement) {
        constructor() {
            super(...arguments);
            this.view = RouterView.Noop;
        }
        // Calling in update to not initiate any new update/render
        update(changedProperties) {
            changedProperties.forEach((oldValue, name) => {
                if (name === "view") {
                    const { styles } = typeof this.view !== "function" ? this.view : this.view();
                    this.adoptRouteViewStyles(styles);
                }
            });
            // Call Super update after adopt self styles
            super.update(changedProperties);
        }
        render() {
            return (0,lit_html__WEBPACK_IMPORTED_MODULE_6__.html) ` ${(0,_directives__WEBPACK_IMPORTED_MODULE_5__.blocksMapView)(this.view)} `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: Object })
    ], Element.prototype, "view", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.customElement)("router-view")
    ], Element);
    RouterView.Element = Element;
})(RouterView || (RouterView = {}));


/***/ }),

/***/ "./src/router/directives.ts":
/*!**********************************!*\
  !*** ./src/router/directives.ts ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   blocksMapView: () => (/* binding */ blocksMapView)
/* harmony export */ });
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-html/directives/repeat */ "lit-html/directives/repeat");
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./index */ "./src/router/index.ts");



// lit-html directive
const blocksMapView = (0,lit_html__WEBPACK_IMPORTED_MODULE_0__.directive)((blocksMapArg) => (part) => {
    if (!(part instanceof lit_html__WEBPACK_IMPORTED_MODULE_0__.NodePart)) {
        throw new Error("cache can only be used in text bindings");
    }
    const blocksMap = blocksMapArg instanceof _index__WEBPACK_IMPORTED_MODULE_2__.Router.RouterView.BlocksMap ? blocksMapArg : blocksMapArg();
    (0,lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_1__.repeat)(blocksMap.blocksWrappersCollection, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    (blockWrapper, index) => blockWrapper.id, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    (blockWrapper, index) => blockWrapper.block.template)(part);
});


/***/ }),

/***/ "./src/router/index.ts":
/*!*****************************!*\
  !*** ./src/router/index.ts ***!
  \*****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Router: () => (/* binding */ Router)
/* harmony export */ });
/* harmony import */ var _directives__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./directives */ "./src/router/directives.ts");
/* harmony import */ var _router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./router */ "./src/router/router.ts");
/* harmony import */ var _RouterLink__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./RouterLink */ "./src/router/RouterLink.ts");
/* harmony import */ var _RouterView__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./RouterView */ "./src/router/RouterView.ts");
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */




var Router;
(function (Router) {
    Router.router = _router__WEBPACK_IMPORTED_MODULE_1__.router;
    Router.blocksMapView = _directives__WEBPACK_IMPORTED_MODULE_0__.blocksMapView;
    Router.RouterLink = _RouterLink__WEBPACK_IMPORTED_MODULE_2__.RouterLink;
    Router.RouterView = _RouterView__WEBPACK_IMPORTED_MODULE_3__.RouterView;
    Router.ROUTE_MIDDLEWARES_KEYS = ["before", "resolver", "after"];
    Router.ROUTER_CONFIG_MIDDLEWARES_KEYS = ["onUpdate", "onBeforeEveryRoute", "onAfterEveryRoute"];
})(Router || (Router = {}));


/***/ }),

/***/ "./src/router/router.ts":
/*!******************************!*\
  !*** ./src/router/router.ts ***!
  \******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   createPageInstance: () => (/* binding */ createPageInstance),
/* harmony export */   createRouter: () => (/* binding */ createRouter),
/* harmony export */   router: () => (/* binding */ router)
/* harmony export */ });
/* harmony import */ var event_emitter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! event-emitter */ "event-emitter");
/* harmony import */ var event_emitter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(event_emitter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var event_emitter_all_off__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! event-emitter/all-off */ "event-emitter/all-off");
/* harmony import */ var event_emitter_all_off__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(event_emitter_all_off__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var page__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! page */ "page");
/* harmony import */ var page__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(page__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var path_to_regexp__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! path-to-regexp */ "path-to-regexp");
/* harmony import */ var path_to_regexp__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(path_to_regexp__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! qs */ "qs");
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../sdk */ "./src/sdk.ts");
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./index */ "./src/router/index.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};







var ERouterInternalEvents;
(function (ERouterInternalEvents) {
    ERouterInternalEvents["PathResolve"] = "PathResolve";
})(ERouterInternalEvents || (ERouterInternalEvents = {}));
const NOT_FOUND_PATH = "*";
const getCollectionDuplicates = (collection) => {
    const counts = collection
        .map((v) => ({
        count: 1,
        value: v
    }))
        .reduce((acc, r) => {
        const strVal = r.value.toString();
        acc[strVal] = (acc[strVal] || 0) + r.count;
        return acc;
    }, {});
    return Object.keys(counts).filter((k) => counts[k] > 1);
};
const getStringifiedValues = (params = {}) => {
    /**
     * e.g. { a: 1, b: [1] } => { a: '1', b: '[1]' }
     */
    return Object.keys(params).reduce((acc, key) => {
        if (typeof params[key] !== "string") {
            acc[key] = JSON.stringify(params[key]);
        }
        else {
            acc[key] = params[key];
        }
        return acc;
    }, {});
};
const getRouteMiddlewaresKeysCount = (route, middlewaresKeys) => {
    return middlewaresKeys.reduce((acc, k) => {
        if (route[k]) {
            return acc + 1;
        }
        return acc;
    }, 0);
};
const routeMiddlewaresInKeys = ["before", "resolver"];
const getIsLastRouteMiddleware = (route, middlewareKey) => {
    // Never stop on exist
    if (middlewareKey === "after") {
        return false;
    }
    const idx = routeMiddlewaresInKeys.indexOf(middlewareKey);
    // Do Not stop on invalid key
    if (idx === -1) {
        return false;
    }
    // const routeMiddlewaresInCount = getRouteMiddlewaresKeysCount(route, routeMiddlewaresInKeys);
    return middlewareKey === "resolver";
};
const getRouteParamsRegExpMapFns = (route) => {
    let mapRegExpGroupsToParams = (g) => g;
    let mapParamsToRegExpGroups = (p) => p;
    if (route && route.regExpGroupsPramsMap) {
        const { regExpGroupsPramsMap } = route;
        /* {
              0: 'id;,
              1: 'action'
           } */
        // reverse map
        const paramsRegExpGroupsMap = Object.keys(regExpGroupsPramsMap).reduce((acc, groupIdx) => {
            acc[regExpGroupsPramsMap[groupIdx]] = groupIdx;
            return acc;
        }, {});
        /* {
              id: 0,
              action: 1
           } */
        mapRegExpGroupsToParams = (groups) => {
            return Object.keys(groups).reduce((acc, groupIdx) => {
                if (regExpGroupsPramsMap[groupIdx]) {
                    const paramName = regExpGroupsPramsMap[groupIdx];
                    acc[paramName] = groups[groupIdx];
                }
                else {
                    const paramName = groupIdx;
                    acc[paramName] = groups[groupIdx];
                }
                return acc;
            }, {});
        };
        mapParamsToRegExpGroups = (params) => {
            return Object.keys(params).reduce((acc, paramName) => {
                if (paramsRegExpGroupsMap[paramName]) {
                    const groupIdx = paramsRegExpGroupsMap[paramName];
                    acc[groupIdx] = params[paramName];
                }
                else {
                    const groupIdx = paramName;
                    acc[groupIdx] = params[paramName];
                }
                return acc;
            }, {});
        };
    }
    return {
        mapRegExpGroupsToParams,
        mapParamsToRegExpGroups
    };
};
class RouterMemo {
    constructor(val = null) {
        this.value = val;
    }
    get value() {
        return this._value;
    }
    set value(val) {
        this._value = JSON.parse(JSON.stringify(val));
    }
}
class RouterProgress {
    constructor() {
        this.progressMap = new Map();
        this.inc = 0;
    }
    add(route, progressData) {
        this.progressMap.set(route, Object.assign(Object.assign({}, progressData), { inc: this.inc }));
        this.inc = this.inc + 1;
    }
    remove(route) {
        this.progressMap.delete(route);
    }
    getLatestRoute() {
        let route = null;
        if (this.count > 0) {
            let inc = -1;
            this.progressMap.forEach((progressData, _route) => {
                if (progressData.inc > inc) {
                    inc = progressData.inc;
                    route = _route;
                }
            });
        }
        return route;
    }
    latestUpdate() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.count > 0) {
                let inc = -1;
                let _update = () => __awaiter(this, void 0, void 0, function* () {
                    return;
                });
                this.progressMap.forEach((progressData) => {
                    if (progressData.inc > inc) {
                        inc = progressData.inc;
                        _update = progressData.update;
                    }
                });
                return _update();
            }
            return false;
        });
    }
    get count() {
        return this.progressMap.size;
    }
}
class RouterService {
    constructor(pageInstanceFactory) {
        // Only internal pub-sub
        this._emitter = event_emitter__WEBPACK_IMPORTED_MODULE_0___default()();
        this.isRunning = false;
        this.routes = [];
        this.routesParamsRegExpMapFns = {};
        this.prevMemo = {
            routePath: new RouterMemo(),
            routeValues: new RouterMemo({
                params: {},
                query: {}
            }),
            routeData: new RouterMemo()
        };
        this.progress = new RouterProgress();
        // Part to resolve async redirect chains
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pathResolvePromises = [];
        // Part to resolve async redirect chains
        this.pathResolveTimeoutRef = undefined;
        this.createPageInstance = () => pageInstanceFactory();
        this.page = this.createPageInstance();
    }
    // Privates
    static validateRoutesConfig(routesConfig) {
        const allRoutesPaths = routesConfig.routes.map((r) => r.path.toString().trim());
        const allRoutesNames = routesConfig.routes.filter((r) => !!r.name).map((r) => r.name.toString().trim());
        // Check routes paths duplicates
        const pathDuplicates = getCollectionDuplicates(allRoutesPaths);
        if (pathDuplicates.length) {
            return {
                valid: false,
                error: `Duplicated routes paths: ${pathDuplicates.join(" ")}`
            };
        }
        // Check routes names duplicates
        const namesDuplicates = getCollectionDuplicates(allRoutesNames);
        if (namesDuplicates.length) {
            return {
                valid: false,
                error: `Duplicated routes names: ${namesDuplicates.join(" ")}`
            };
        }
        // Check duplicated in one route redirect settings
        const errDuplicatedRedirectSettingsRoute = routesConfig.routes.find((r) => {
            if (r.pathsRedirectFrom && getCollectionDuplicates(r.pathsRedirectFrom).length) {
                return true;
            }
            return !!(r.namesRedirectFrom && getCollectionDuplicates(r.namesRedirectFrom).length);
        });
        if (errDuplicatedRedirectSettingsRoute) {
            return {
                valid: false,
                error: `Duplicated redirect settings names for route "${errDuplicatedRedirectSettingsRoute.path}"`
            };
        }
        // TODO: Check duplicated in different routes from
        // Check redirect names exist
        const errNonExistNameRedirectSettingsRoute = routesConfig.routes.find((r) => {
            if (r.namesRedirectFrom) {
                return r.namesRedirectFrom.find((name) => allRoutesNames.indexOf(name) === -1);
            }
            return false;
        });
        if (errNonExistNameRedirectSettingsRoute) {
            return {
                valid: false,
                error: `Non-exist name redirect settings for route "${errNonExistNameRedirectSettingsRoute.path}"`
            };
        }
        return {
            valid: true
        };
    }
    static validateConfig(config) {
        return RouterService.validateRoutesConfig(config); // This might be not alone config check
    }
    initializeConfig(config) {
        const validationResult = RouterService.validateConfig(config);
        if (!validationResult.valid) {
            const message = `Router config is invalid: ${validationResult.error}`;
            _sdk__WEBPACK_IMPORTED_MODULE_5__.logger.error(message);
            throw new Error(message);
        }
        this.config = config;
        this.routes = [
            // All passed routes
            ...config.routes,
            // Other required routes
            ...[
                Object.assign(Object.assign({}, config.notFound), { path: NOT_FOUND_PATH })
            ]
        ];
    }
    bindRoutesToPageJS() {
        this.routesParamsRegExpMapFns = this.routes.reduce((acc, route) => {
            acc[route.path] = getRouteParamsRegExpMapFns(route);
            return acc;
        }, {});
        // Match query strings
        this.page("*", // Any
        // parse query
        (ctx, next) => {
            // ctx.query = qs.parse(window.location.search.slice(1));
            ctx.query = qs__WEBPACK_IMPORTED_MODULE_4___default().parse(ctx.querystring);
            next();
        });
        // Bind prev route path memo
        this.prevMemo.routePath = new RouterMemo();
        // Bind route values memo
        this.prevMemo.routeValues = new RouterMemo({
            params: {},
            query: {}
        });
        // Bind prev route data memo
        this.prevMemo.routeData = new RouterMemo();
        const createRouteMiddleware = (route, middlewareKey) => {
            const isLastRouteMiddleware = getIsLastRouteMiddleware(route, middlewareKey);
            // Middleware
            return (ctx, next) => {
                const middleware = route[middlewareKey];
                const prevRoutePath = this.prevMemo.routePath.value;
                const prevRouteValues = this.prevMemo.routeValues.value;
                const prevRouteData = this.prevMemo.routeData.value;
                const routePath = route.path;
                const routeValues = {
                    params: this.routesParamsRegExpMapFns[routePath].mapRegExpGroupsToParams(ctx.params || {}),
                    query: ctx.query || {}
                };
                const routeData = route.data ? route.data() : null;
                const routeMiddlewarePayload = {
                    routePath,
                    routeValues,
                    routeData,
                    prevRoutePath,
                    prevRouteValues,
                    prevRouteData
                };
                const updateMiddlewarePayload = Object.assign(Object.assign({}, routeMiddlewarePayload), { middlewareKey });
                const update = () => __awaiter(this, void 0, void 0, function* () {
                    if (this.config.onUpdate) {
                        yield this.config.onUpdate(updateMiddlewarePayload);
                    }
                });
                this.progress.add(route, {
                    update,
                    middlewareKey
                });
                (() => __awaiter(this, void 0, void 0, function* () {
                    const routeMiddlewaresInCount = getRouteMiddlewaresKeysCount(route, routeMiddlewaresInKeys);
                    // Optional routing "before" change propagation before route callback
                    if (this.config.onBeforeEveryRoute &&
                        ((middlewareKey === "resolver" && routeMiddlewaresInCount === 1) ||
                            (middlewareKey === "before" && routeMiddlewaresInCount === 2))) {
                        const res = yield this.config.onBeforeEveryRoute(updateMiddlewarePayload);
                        if (res === false) {
                            yield this.progress.latestUpdate();
                            return;
                        }
                    }
                    // Passing route params to next components
                    {
                        const res = yield middleware(routeMiddlewarePayload);
                        if (res === false) {
                            yield this.progress.latestUpdate();
                            return;
                        }
                    }
                    // Optional routing "after" change propagation after route callback
                    if (this.config.onAfterEveryRoute && middlewareKey === "after") {
                        const res = yield this.config.onAfterEveryRoute(updateMiddlewarePayload);
                        if (res === false) {
                            yield this.progress.latestUpdate();
                            return;
                        }
                    }
                    // Optional routing change propagation after each callback
                    //await update();
                    yield this.progress.latestUpdate();
                    if (middlewareKey === "resolver") {
                        this._emitter.emit(ERouterInternalEvents.PathResolve, routeMiddlewarePayload);
                    }
                    /*
                    // Debug log - do not remove
                    logger.log(
                      `[SUCCESS ${isLastRouteMiddleware ? 'FINAL ' : ' '}"${middlewareKey}"]`,
                      ` -> route path: "${routePath}"`,
                      ' -> route values: ',
                      routeValues,
                      ` -> prev route path: "${prevRoutePath}"`,
                      ' -> prev route values: ',
                      prevRouteValues,
                    );
                    */
                }))()
                    .catch((e) => {
                    _sdk__WEBPACK_IMPORTED_MODULE_5__.logger.error(`[ERROR "${middlewareKey}"]`, ` -> route path: ${routePath}`, ` -> error: ${e}`);
                })
                    .finally(() => {
                    if (!isLastRouteMiddleware) {
                        next();
                    }
                    else {
                        // otherwise - matched stop!
                        this.prevMemo.routePath.value = routePath;
                        this.prevMemo.routeValues.value = routeValues;
                        this.prevMemo.routeData.value = routeData;
                    }
                    this.progress.remove(route);
                });
            };
        };
        this.routes.forEach((route) => {
            // Static Redirects
            // eslint-disable-next-line no-lone-blocks
            {
                if (route.pathsRedirectFrom) {
                    const pathTo = route.path;
                    route.pathsRedirectFrom.forEach((pathFrom) => {
                        this.page.redirect(pathFrom, pathTo);
                    });
                }
                if (route.namesRedirectFrom) {
                    route.namesRedirectFrom.forEach((nameFrom) => {
                        const _route = this.routes.find((r) => r.name === nameFrom);
                        if (_route) {
                            const pathFrom = _route.path;
                            const pathTo = route.path;
                            this.page.redirect(pathFrom, pathTo);
                        }
                    });
                }
            }
            // To Route path middlewares
            // eslint-disable-next-line no-lone-blocks
            {
                if (route["before"] || route["resolver"]) {
                    this.page(route.path, ...["before", "resolver"].reduce((acc, middlewareKey) => {
                        if (route[middlewareKey]) {
                            acc.push(createRouteMiddleware(route, middlewareKey));
                        }
                        return acc;
                    }, []));
                }
            }
            // Out Route middlewares
            // eslint-disable-next-line no-lone-blocks
            {
                if (route["after"]) {
                    this.page.exit(route.path, createRouteMiddleware(route, "after"));
                }
                else if (!route["after"] && route.path !== NOT_FOUND_PATH && this.config.onAfterEveryRoute) {
                    this.page.exit(route.path, createRouteMiddleware(Object.assign(Object.assign({}, route), { after: () => __awaiter(this, void 0, void 0, function* () {
                            /**/
                        }) }), "after"));
                }
            }
        });
    }
    buildPathUrl(route, routeValues) {
        const routePath = route.path;
        if (routePath === NOT_FOUND_PATH) {
            // Compile is not support '*'
            return routePath;
        }
        // https://github.com/pillarjs/path-to-regexp#compile-reverse-path-to-regexp
        const toPathBuildFn = (0,path_to_regexp__WEBPACK_IMPORTED_MODULE_3__.compile)(routePath, { encode: encodeURIComponent });
        const path = toPathBuildFn(this.routesParamsRegExpMapFns[routePath].mapParamsToRegExpGroups(
        // have to map all params values toString()
        getStringifiedValues(routeValues ? routeValues.params : {})));
        const query = routeValues && routeValues.query
            ? Object.keys(getStringifiedValues(routeValues.query)).reduce((acc, key, idx) => {
                return `${acc}${idx === 0 ? "?" : "&"}${key}=${routeValues.query[key]}`;
            }, "")
            : "";
        return `${path}${query}`;
    }
    // Part to resolve async redirect chains
    onPathResolve() {
        clearTimeout(this.pathResolveTimeoutRef);
        this.pathResolveTimeoutRef = window.setTimeout(() => {
            this.pathResolvePromises.forEach((resolve) => resolve());
            this.pathResolvePromises.length = 0;
        });
    }
    whenCurrentPathResolved() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.pathResolvePromises.length) {
                yield this.whenNextPathResolved();
            }
            return Promise.resolve();
        });
    }
    // Part to resolve async redirect chains
    whenNextPathResolved() {
        return __awaiter(this, void 0, void 0, function* () {
            /**
             * Since multiple redirects can appear in a row - setting resolve chain
             */
            this._emitter.once(ERouterInternalEvents.PathResolve, () => this.onPathResolve());
            return new Promise((resolve) => this.pathResolvePromises.push(resolve));
        });
    }
    // Check path resolve in progress
    get isPathResolveInProgress() {
        return !!this.pathResolvePromises.length;
    }
    // Re-initialization service in case of adding new routes in runtime
    restart(config) {
        return __awaiter(this, void 0, void 0, function* () {
            // Detaching handlers of current route & config
            // Hanlde Current route
            const currentRoute = this.routes.find((r) => r.path === this.prevMemo.routePath.value);
            let currentRouteRealMiddlewares = {};
            const detachCurrentRouteHandlers = () => {
                //Handle Current Route
                if (currentRoute) {
                    // Memoizing real middlewares
                    currentRouteRealMiddlewares = _index__WEBPACK_IMPORTED_MODULE_6__.Router.ROUTE_MIDDLEWARES_KEYS.reduce((acc, key) => {
                        if (currentRoute[key]) {
                            acc[key] = currentRoute[key];
                        }
                        return acc;
                    }, {});
                    //Detaching real route middlewares and setting dumb
                    Object.keys(currentRouteRealMiddlewares).forEach((key) => {
                        currentRoute[key] = () => __awaiter(this, void 0, void 0, function* () {
                            return;
                        });
                    });
                }
            };
            const attachCurrentRouteHandlers = () => {
                if (currentRoute) {
                    //Attach real route middlewares
                    Object.keys(currentRouteRealMiddlewares).forEach((key) => {
                        currentRoute[key] = currentRouteRealMiddlewares[key];
                    });
                }
            };
            //Handle Config
            let configMiddlewares = {};
            //let notFoundMiddlewares: Partial<Record<Router.RouteMiddlewareKey, Router.RouteMiddleware>> = {};
            const detachConfigHandlers = () => {
                //Memoizind config middlewares
                configMiddlewares = _index__WEBPACK_IMPORTED_MODULE_6__.Router.ROUTER_CONFIG_MIDDLEWARES_KEYS.reduce((acc, key) => {
                    if (config[key]) {
                        acc[key] = config[key];
                    }
                    return acc;
                }, {});
                //Detaching real config middlewares and setting dumb
                Object.keys(configMiddlewares).forEach((key) => {
                    config[key] = () => __awaiter(this, void 0, void 0, function* () {
                        return;
                    });
                });
            };
            const attachConfigHandlers = () => {
                //Attaching real config middlewares
                Object.keys(configMiddlewares).forEach((key) => {
                    config[key] = configMiddlewares[key];
                });
            };
            // PageJS instance re-create
            const restart = () => __awaiter(this, void 0, void 0, function* () {
                // In case of some navigation in progress - TO NOT BREAK IT - checking
                // await current resolved
                yield this.whenCurrentPathResolved();
                // Detaching handlers to not fire change
                detachCurrentRouteHandlers();
                detachConfigHandlers();
                // Re-creating
                this.stop();
                this.page = this.createPageInstance();
                this.start(config);
                // await resolved - after start
                if (currentRoute && currentRoute.path !== NOT_FOUND_PATH) {
                    yield this.whenNextPathResolved();
                }
                attachConfigHandlers();
                attachCurrentRouteHandlers();
            });
            yield restart();
        });
    }
    // Publics
    // Getters
    get currentPathUrl() {
        return this.page.current;
    }
    // Lifecycle Methods
    start(config) {
        this.stop(); // just in case
        this.initializeConfig(config);
        this.bindRoutesToPageJS();
        this.isRunning = true;
        this.page.start({
            click: false // Handling clicks manually via RouterLink only
        });
    }
    stop() {
        this.page.stop();
        event_emitter_all_off__WEBPACK_IMPORTED_MODULE_1___default()(this._emitter);
        this.isRunning = false;
    }
    //Get routes list
    getRoutes() {
        return this.config.routes;
    }
    // Dynamically add routes in runtime
    addRoutes(routes) {
        return __awaiter(this, void 0, void 0, function* () {
            if (routes.length) {
                const newConfigRoutes = [...this.config.routes, ...routes];
                // Checking new config first
                const res = RouterService.validateRoutesConfig({
                    routes: newConfigRoutes
                });
                if (res.valid) {
                    yield this.restart(Object.assign(Object.assign({}, this.config), { routes: newConfigRoutes }));
                    _sdk__WEBPACK_IMPORTED_MODULE_5__.logger.info("Added new routes: ", routes.map((r) => r.path));
                }
                else {
                    _sdk__WEBPACK_IMPORTED_MODULE_5__.logger.error("New routes params are invalid: ", res.error);
                }
            }
            else {
                _sdk__WEBPACK_IMPORTED_MODULE_5__.logger.info("No routes to add");
            }
        });
    }
    // Dynamically update routes in runtime
    updateRoutes(update_routes) {
        return __awaiter(this, void 0, void 0, function* () {
            const newConfigRoutes = this.config.routes.reduce((acc, old_route) => {
                const candidate_update_route_tuple = update_routes.find((update_route_tuple) => {
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars,sonarjs/no-dead-store,sonarjs/no-unused-vars
                    const [old_route_identity, new_route] = update_route_tuple;
                    return (old_route.path === old_route_identity.path || (old_route.name && old_route.name === old_route_identity.name));
                });
                if (candidate_update_route_tuple) {
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars,sonarjs/no-dead-store,sonarjs/no-unused-vars
                    const [old_route_identity, new_route] = candidate_update_route_tuple;
                    acc.push(new_route);
                }
                else {
                    acc.push(old_route);
                }
                return acc;
            }, []);
            // Checking new config first
            const res = RouterService.validateRoutesConfig({
                routes: newConfigRoutes
            });
            if (res.valid) {
                yield this.restart(Object.assign(Object.assign({}, this.config), { routes: newConfigRoutes }));
                _sdk__WEBPACK_IMPORTED_MODULE_5__.logger.info("Updated routes: ", update_routes
                    .map((t) => {
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars,sonarjs/no-dead-store,sonarjs/no-unused-vars
                    const [old_route_identity, new_route] = t;
                    return old_route_identity;
                })
                    .map((r) => r.path));
            }
            else {
                _sdk__WEBPACK_IMPORTED_MODULE_5__.logger.error("Update routes params are invalid: ", res.error);
            }
        });
    }
    // Dynamically remove routes in runtime
    removeRoutes(remove_routes) {
        return __awaiter(this, void 0, void 0, function* () {
            const newConfigRoutes = this.config.routes.filter((r) => {
                const candidate_remove_route = remove_routes.find((_r) => {
                    return r.path === _r.path || (r.name && r.name === _r.name);
                });
                return !candidate_remove_route;
            });
            //
            if (newConfigRoutes.length < this.config.routes.length) {
                // Checking new config first
                const res = RouterService.validateRoutesConfig({
                    routes: newConfigRoutes
                });
                if (res.valid) {
                    yield this.restart(Object.assign(Object.assign({}, this.config), { routes: newConfigRoutes }));
                    _sdk__WEBPACK_IMPORTED_MODULE_5__.logger.info("Removed routes: ", remove_routes);
                }
                else {
                    _sdk__WEBPACK_IMPORTED_MODULE_5__.logger.error("New routes params are invalid: ", res.error);
                }
            }
            else {
                _sdk__WEBPACK_IMPORTED_MODULE_5__.logger.info("No routes to remove under provided conditions: ", remove_routes);
            }
        });
    }
    // Behaviour Methods
    // build path url from route name and params
    buildNamedRoutePathUrl(routeName, routeValues) {
        if (!this.isRunning) {
            const message = `Router is not running and unable to build pathUrl. Please run start(...) first.`;
            _sdk__WEBPACK_IMPORTED_MODULE_5__.logger.error(message);
            throw new Error(message);
        }
        const route = this.routes.find((r) => r.name === routeName);
        if (!route) {
            const message = `Route with name "${routeName}" is not exists`;
            _sdk__WEBPACK_IMPORTED_MODULE_5__.logger.error(message);
            throw new Error(message);
        }
        return this.buildPathUrl(route, routeValues);
    }
    // build path url from route name and params
    buildRoutePathUrl(routePath, routeValues) {
        if (!this.isRunning) {
            const message = `Router is not running and unable to build pathUrl. Please run start(...) first.`;
            _sdk__WEBPACK_IMPORTED_MODULE_5__.logger.error(message);
            throw new Error(message);
        }
        const route = this.routes.find((r) => r.path === routePath);
        if (!route) {
            const message = `Route with path "${routePath}" is not exists`;
            _sdk__WEBPACK_IMPORTED_MODULE_5__.logger.error(message);
            throw new Error(message);
        }
        return this.buildPathUrl(route, routeValues);
    }
    getRouteNameByPath(path) {
        const route = this.routes.find((r) => r.path === path);
        if (route && route.name) {
            return route.name;
        }
        return undefined;
    }
    getRoutePathByName(name) {
        const route = this.routes.find((r) => r.name === name);
        if (route) {
            return route.path;
        }
        return undefined;
    }
    // Navigate
    navigatePathUrl(pathUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.isRunning) {
                const message = `Router is not running and unable to navigate to path url: "${pathUrl}". Please run start(...) first.`;
                _sdk__WEBPACK_IMPORTED_MODULE_5__.logger.error(message);
                throw new Error(message);
            }
            // Checking if not on current
            if (this.currentPathUrl === pathUrl) {
                return;
            }
            this.page.show(pathUrl); // TODO: check if registered
            // TBD: maybe timeout race ?
            yield this.whenNextPathResolved();
        });
    }
    navigateNamedRoute(routeName, routeValues) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.isRunning) {
                const message = `Router is not running and unable to navigate to route name: ${routeName}. Please run start(...) first.`;
                _sdk__WEBPACK_IMPORTED_MODULE_5__.logger.error(message);
                throw new Error(message);
            }
            const pathUrl = this.buildNamedRoutePathUrl(routeName, routeValues);
            yield this.navigatePathUrl(pathUrl);
        });
    }
    // Redirect
    redirectPathUrl(pathUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.isRunning) {
                const message = `Router is not running and unable to redirect to path url: "${pathUrl}". Please run start(...) first.`;
                _sdk__WEBPACK_IMPORTED_MODULE_5__.logger.error(message);
                throw new Error(message);
            }
            // Checking if not on current
            if (this.currentPathUrl === pathUrl) {
                return;
            }
            this.page.redirect(pathUrl); // TODO: check if registered
            // TBD: maybe timeout race ?
            yield this.whenNextPathResolved();
        });
    }
    redirectNamedRoute(routeName, routeValues) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.isRunning) {
                const message = `Router is not running and unable to redirect to " route name ${routeName}". Please run start(...) first.`;
                _sdk__WEBPACK_IMPORTED_MODULE_5__.logger.error(message);
                throw new Error(message);
            }
            const pathUrl = this.buildNamedRoutePathUrl(routeName, routeValues);
            yield this.redirectPathUrl(pathUrl);
        });
    }
    // Run Promise with route consistency check
    runInMiddlewarePromise(p) {
        return __awaiter(this, void 0, void 0, function* () {
            const pathUrlBefore = this.currentPathUrl;
            const res = yield p();
            const pathUrlAfter = this.currentPathUrl;
            return {
                isRouteConsistent: pathUrlBefore === pathUrlAfter,
                res
            };
        });
    }
}
const createPageInstance = () => page__WEBPACK_IMPORTED_MODULE_2___default().create({ window });
const createRouter = (pageInstanceFactory = createPageInstance /* Injecting page instance factory */) => {
    return new RouterService(pageInstanceFactory);
};
const router = createRouter();


/***/ }),

/***/ "./src/sdk.ts":
/*!********************!*\
  !*** ./src/sdk.ts ***!
  \********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   logger: () => (/* binding */ logger)
/* harmony export */ });
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @uuip/unified-ui-platform-sdk */ "@uuip/unified-ui-platform-sdk");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__);

const logger = (0,_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.createLogger)("unified-ui-platform");


/***/ }),

/***/ "./src/widgets/DynamicLayout.scss":
/*!****************************************!*\
  !*** ./src/widgets/DynamicLayout.scss ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  --resize-border: 1px;
  --resize-border-color: var(--md-default-focus-outline-color, #007aa3);
  --area-highlight-color: #00a0d1;
}

.container {
  display: grid;
}
.container .widget {
  position: relative;
  min-width: 0;
  overflow: hidden;
}
.container .widget uuip-dynamic-widget {
  max-width: 100%;
}
.container .widget.edit {
  cursor: grab;
}
.container .widget.edit .dynamic {
  pointer-events: none;
}
.container .widget.drag {
  cursor: move;
}
.container .widget.drag-over .resize {
  background-color: var(--area-highlight-color);
}
.container .widget.drag-over::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  background-color: rgba(255, 255, 255, 0.3);
}
.container .widget .resize {
  position: absolute;
  background-color: var(--resize-border-color);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  transition: background-color 0.15s ease-in-out;
}
.container .widget .resize.top {
  cursor: ns-resize;
  bottom: auto;
  height: var(--resize-border);
}
.container .widget .resize.bottom {
  cursor: ns-resize;
  top: auto;
  height: var(--resize-border);
}
.container .widget .resize.left {
  cursor: ew-resize;
  right: auto;
  width: var(--resize-border);
}
.container .widget .resize.right {
  cursor: ew-resize;
  left: auto;
  width: var(--resize-border);
}
.container .widget .resize-diagonal {
  position: absolute;
  background-color: transparent;
  width: 25px;
  height: 25px;
  z-index: 11;
  transition: background-color 0.15s ease-in-out;
}
.container .widget .resize-diagonal.top-left {
  cursor: nwse-resize;
  top: 0;
  left: 0;
}
.container .widget .resize-diagonal.top-right {
  cursor: nesw-resize;
  top: 0;
  right: 0;
}
.container .widget .resize-diagonal.bottom-left {
  cursor: nesw-resize;
  bottom: 0;
  left: 0;
}
.container .widget .resize-diagonal.bottom-right {
  cursor: nwse-resize;
  bottom: 0;
  right: 0;
}
/*# sourceURL=/home/jenkins/agent/workspace/cicd-jobs/wxcc-common-CI-Builder/packages/@uuip/unified-ui-platform/src/widgets/DynamicLayout.scss */
/*# sourceURL=DynamicLayout.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/widgets/DynamicLayout.ts":
/*!**************************************!*\
  !*** ./src/widgets/DynamicLayout.ts ***!
  \**************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   DynamicLayout: () => (/* binding */ DynamicLayout)
/* harmony export */ });
/* harmony import */ var _widgets_src_validate__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/widgets/src/validate */ "./src/widgets/src/validate/index.ts");
/* harmony import */ var _widgets_src_validate_persist__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/widgets/src/validate/persist */ "./src/widgets/src/validate/persist.ts");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @uuip/unified-ui-platform-sdk */ "@uuip/unified-ui-platform-sdk");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-html/directives/class-map */ "lit-html/directives/class-map");
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lit-html/directives/style-map */ "lit-html/directives/style-map");
/* harmony import */ var lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var nanoid__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! nanoid */ "nanoid");
/* harmony import */ var nanoid__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(nanoid__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _DynamicLayout_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./DynamicLayout.scss */ "./src/widgets/DynamicLayout.scss");
/* eslint-disable @typescript-eslint/no-explicit-any */
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};









const PERSIST = new _widgets_src_validate_persist__WEBPACK_IMPORTED_MODULE_1__.DynamicWidgetsPersist();
const VALIDATE = new _widgets_src_validate__WEBPACK_IMPORTED_MODULE_0__.DynamicWidgetsValidate();
const MIN_SIZE = 0.1;
const IMG = document.createElement("img");
IMG.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
var DynamicLayout;
(function (DynamicLayout) {
    var Element_1;
    /**
     * @element uuip-dynamic-widgets
     * @fires error
     * @fires widgetStatus
     * @fires widgetError
     */
    let Element = Element_1 = class Element extends lit_element__WEBPACK_IMPORTED_MODULE_3__.LitElement {
        constructor() {
            super(...arguments);
            this.edit = false;
            this.width = "100%";
            this.height = "500px";
            this.isError = true;
            this.drag = "";
            this.dragOver = "";
            // FIREFOX bug
            // using dragover for mouse X/Y
            // https://stackoverflow.com/a/33672982
            this.eX = 0;
            this.eY = 0;
            this.isResizing = false;
            this.onResize = (layout, e, isCols, i) => {
                var _a;
                this.isResizing = true;
                const colsBase = [...layout.size.cols];
                const wSum = colsBase.reduce((a, b) => a + b, 0);
                const w = this.elContainer.clientWidth;
                const rowsBase = [...layout.size.rows];
                const hSum = rowsBase.reduce((a, b) => a + b, 0);
                const h = this.elContainer.clientHeight;
                const t = e.target;
                (_a = e.dataTransfer) === null || _a === void 0 ? void 0 : _a.setDragImage(IMG, 0, 0);
                const orgX = e.x;
                const orgY = e.y;
                this.eX = e.x;
                this.eY = e.y;
                let posX = -1;
                let posY = -1;
                const drag = () => {
                    if (isCols) {
                        const eX = this.eX;
                        if (posX !== eX && eX !== 0) {
                            posX = eX;
                            const deltaX = posX - orgX;
                            const amountX = (Math.abs(deltaX) / w) * wSum;
                            const increaseIdx = deltaX > 0 ? i - 1 : i;
                            const increase = colsBase[increaseIdx] + amountX;
                            const decreaseIdx = deltaX > 0 ? i : i - 1;
                            const decrease = colsBase[decreaseIdx] - amountX;
                            if (decrease > MIN_SIZE * wSum) {
                                layout.size.cols[increaseIdx] = increase;
                                layout.size.cols[decreaseIdx] = decrease;
                                this.requestUpdate();
                            }
                        }
                    }
                    else {
                        const eY = this.eY;
                        if (posY !== eY && eY !== 0) {
                            posY = eY;
                            const deltaY = posY - orgY;
                            const amountY = (Math.abs(deltaY) / h) * hSum;
                            const increaseIdx = deltaY > 0 ? i - 1 : i;
                            const increase = rowsBase[increaseIdx] + amountY;
                            const decreaseIdx = deltaY > 0 ? i : i - 1;
                            const decrease = rowsBase[decreaseIdx] - amountY;
                            if (decrease > MIN_SIZE * hSum) {
                                layout.size.rows[increaseIdx] = increase;
                                layout.size.rows[decreaseIdx] = decrease;
                                this.requestUpdate();
                            }
                        }
                    }
                };
                const dragOver = (evt) => {
                    this.eX = evt.x;
                    this.eY = evt.y;
                };
                const dragEnd = () => {
                    this.isResizing = false;
                    t.removeEventListener("drag", drag);
                    t.removeEventListener("dragend", dragEnd);
                    document.removeEventListener("dragover", dragOver);
                };
                t.addEventListener("drag", drag);
                t.addEventListener("dragend", dragEnd);
                document.addEventListener("dragover", dragOver);
            };
        }
        static get styles() {
            return _DynamicLayout_scss__WEBPACK_IMPORTED_MODULE_8__["default"];
        }
        updated(p) {
            super.updated(p);
            if (p.has("page") || p.has("visibilityCheck") || p.has("dataProvider")) {
                const check = VALIDATE.page(this.page, this.pageJson);
                this.isError = check.isError;
                if (check.isError) {
                    this.error.emit({
                        isValidationError: true,
                        page: this.page,
                        messages: check.messages,
                        json: check.json
                    });
                }
                else {
                    this.PAGE = this.page;
                    this.widgets = this.page.widgets;
                    this.layouts = PERSIST.load(this.PAGE);
                    this.requestUpdate();
                }
            }
        }
        save() {
            this.edit = false;
            PERSIST.save(this.PAGE, this.layouts);
        }
        reset() {
            this.edit = false;
            this.layouts = PERSIST.reset(this.PAGE);
            this.requestUpdate();
        }
        cancel() {
            this.edit = false;
            this.layouts = PERSIST.load(this.PAGE);
            this.requestUpdate();
        }
        render() {
            if (this.isError) {
                return lit_html__WEBPACK_IMPORTED_MODULE_4__.nothing;
            }
            const s = {
                width: this.width,
                height: this.height
            };
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) ` <div style=${(0,lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_6__.styleMap)(s)}>${this.renderLayout(this.layouts.ROOT, "ROOT")}</div> `;
        }
        renderLayout(layout, layoutName) {
            const s = {
                height: "100%",
                "grid-template-columns": layout.size.cols.map((x) => `${x}fr`).join(" "),
                "grid-template-rows": layout.size.rows.map((x) => `${x}fr`).join(" "),
                "grid-template-areas": layout.areas
                    .reduce((acc, p) => `${acc}"${p.map((x) => (x[0] === "-" ? "." : x)).join(" ")}" `, "")
                    .slice(0, -1)
            };
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        <div part="container" class="container" style=${(0,lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_6__.styleMap)(s)}>
          ${this.getCells(layout).map((c) => this.renderCell(layout, layoutName, c))}
        </div>
      `;
        }
        renderCell(layout, layoutName, cell) {
            const s = { "grid-area": cell.name };
            const options = this.widgets[cell.name];
            const dwParentId = `uuip-widget-${cell.name}_${(0,nanoid__WEBPACK_IMPORTED_MODULE_7__.nanoid)(6)}`;
            const dwId = `uuip-dw-${cell.name}_${(0,nanoid__WEBPACK_IMPORTED_MODULE_7__.nanoid)(6)}`;
            if (cell.subCells) {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
          <div
            id=${dwParentId}
            class=${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_5__.classMap)({ widget: true, edit: this.edit })}
            part="widget"
            style=${(0,lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_6__.styleMap)(s)}
            draggable=${false}
          >
            ${this.renderLayout(cell.subCells.layout, cell.subCells.name)}
            <!---->
            ${this.renderCellResize(layout, cell)}
          </div>
        `;
            }
            else {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
          <div
            id=${dwParentId}
            class=${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_5__.classMap)({
                    widget: true,
                    edit: this.edit,
                    drag: this.drag === `${layoutName}>>>${cell.name}`,
                    "drag-over": this.dragOver === `${layoutName}>>>${cell.name}`
                })}
            part="widget"
            style=${(0,lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_6__.styleMap)(s)}
            draggable=${this.edit}
            @dragstart=${() => {
                    if (this.isResizing) {
                        return;
                    }
                    this.drag = `${layoutName}>>>${cell.name}`;
                }}
            @dragenter=${() => {
                    if (this.isResizing) {
                        return;
                    }
                    this.dragOver = `${layoutName}>>>${cell.name}`;
                }}
            @dragend=${() => {
                    this.drag = "";
                    this.dragOver = "";
                }}
            @dragover=${(e) => {
                    e.preventDefault();
                    return false;
                }}
            @drop=${(e) => {
                    if (this.isResizing) {
                        return;
                    }
                    e.stopPropagation();
                    this.onDrop();
                }}
          >
            <!-- DYNAMMIC WIDGET or SLOT -->
            <uuip-dynamic-widget
              id=${dwId}
              .options=${options}
              .dataProvider=${this.dataProvider}
              .visibilityCheck=${this.visibilityCheck}
              ?edit=${this.edit}
              class=${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_5__.classMap)({ dynamic: true, edit: this.edit })}
            ></uuip-dynamic-widget>

            ${this.renderCellResize(layout, cell)}
          </div>
        `;
            }
        }
        renderCellResize(layout, cell) {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        ${this.edit
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
              ${cell.top !== undefined
                    ? (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
                    <div
                      class="resize top"
                      draggable="true"
                      @dragstart=${(e) => this.onResize(layout, e, false, cell.top)}
                    ></div>
                  `
                    : lit_html__WEBPACK_IMPORTED_MODULE_4__.nothing}
              ${cell.bottom !== undefined
                    ? (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
                    <div
                      class="resize bottom"
                      draggable="true"
                      @dragstart=${(e) => this.onResize(layout, e, false, cell.bottom)}
                    ></div>
                  `
                    : lit_html__WEBPACK_IMPORTED_MODULE_4__.nothing}
              ${cell.right !== undefined
                    ? (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
                    <div
                      class="resize right"
                      draggable="true"
                      @dragstart=${(e) => this.onResize(layout, e, true, cell.right)}
                    ></div>
                  `
                    : lit_html__WEBPACK_IMPORTED_MODULE_4__.nothing}
              ${cell.left !== undefined
                    ? (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
                    <div
                      class="resize left"
                      draggable="true"
                      @dragstart=${(e) => this.onResize(layout, e, true, cell.left)}
                    ></div>
                  `
                    : lit_html__WEBPACK_IMPORTED_MODULE_4__.nothing}
            `
                : lit_html__WEBPACK_IMPORTED_MODULE_4__.nothing}

        <!-- DIAGONAL RESIZE -->
        ${this.edit
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
              ${cell.top !== undefined && cell.left !== undefined
                    ? (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
                    <div
                      class="resize-diagonal top-left"
                      draggable="true"
                      @dragstart=${(e) => {
                        this.onResize(layout, e, false, cell.top);
                        this.onResize(layout, e, true, cell.left);
                    }}
                    ></div>
                  `
                    : lit_html__WEBPACK_IMPORTED_MODULE_4__.nothing}
              ${cell.top !== undefined && cell.right !== undefined
                    ? (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
                    <div
                      class="resize-diagonal top-right"
                      draggable="true"
                      @dragstart=${(e) => {
                        this.onResize(layout, e, false, cell.top);
                        this.onResize(layout, e, true, cell.right);
                    }}
                    ></div>
                  `
                    : lit_html__WEBPACK_IMPORTED_MODULE_4__.nothing}
              ${cell.bottom !== undefined && cell.left !== undefined
                    ? (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
                    <div
                      class="resize-diagonal bottom-left"
                      draggable="true"
                      @dragstart=${(e) => {
                        this.onResize(layout, e, false, cell.bottom);
                        this.onResize(layout, e, true, cell.left);
                    }}
                    ></div>
                  `
                    : lit_html__WEBPACK_IMPORTED_MODULE_4__.nothing}
              ${cell.bottom !== undefined && cell.right !== undefined
                    ? (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
                    <div
                      class="resize-diagonal bottom-right"
                      draggable="true"
                      @dragstart=${(e) => {
                        this.onResize(layout, e, false, cell.bottom);
                        this.onResize(layout, e, true, cell.right);
                    }}
                    ></div>
                  `
                    : lit_html__WEBPACK_IMPORTED_MODULE_4__.nothing}
            `
                : lit_html__WEBPACK_IMPORTED_MODULE_4__.nothing}
      `;
        }
        // ------------------------------
        getCells(layout) {
            const cells = [];
            const rows = layout.areas.length;
            const cols = layout.areas[0].length;
            for (let row = 0; row < rows; row++) {
                for (let col = 0; col < cols; col++) {
                    const name = layout.areas[row][col];
                    const isFirstRow = row === 0;
                    const ifFirstCol = col === 0;
                    const isLastRow = row === rows - 1;
                    const ifLastCol = col === cols - 1;
                    const isCollapsedTop = isFirstRow ? false : name === layout.areas[row - 1][col];
                    const isCollapsedLeft = ifFirstCol ? false : name === layout.areas[row][col - 1];
                    if (isCollapsedTop) {
                        const c = cells.find((c) => c.name === name);
                        c.bottom = isLastRow ? undefined : row + 1;
                    }
                    else if (isCollapsedLeft) {
                        const c = cells.find((c) => c.name === name);
                        c.right = ifLastCol ? undefined : col + 1;
                    }
                    else {
                        cells.push({
                            name,
                            top: isFirstRow ? undefined : row,
                            bottom: isLastRow ? undefined : row + 1,
                            left: ifFirstCol ? undefined : col,
                            right: ifLastCol ? undefined : col + 1,
                            subCells: this.layouts[name] ? { name, layout: this.layouts[name] } : undefined
                        });
                    }
                }
            }
            return cells;
        }
        onDrop() {
            if (!this.drag.trim() || !this.dragOver.trim()) {
                return;
            }
            const { 0: fromLayout, 1: fromCell } = this.drag.split(">>>");
            const { 0: toLayout, 1: toCell } = this.dragOver.split(">>>");
            if (fromLayout === toLayout) {
                for (let i = 0; i < this.layouts[toLayout].areas.length; i++) {
                    for (let j = 0; j < this.layouts[toLayout].areas[i].length; j++) {
                        const c = this.layouts[toLayout].areas[i][j];
                        if (c === fromCell) {
                            this.layouts[toLayout].areas[i][j] = toCell;
                        }
                        else if (c === toCell) {
                            this.layouts[toLayout].areas[i][j] = fromCell;
                        }
                    }
                }
            }
            else {
                for (let i = 0; i < this.layouts[toLayout].areas.length; i++) {
                    for (let j = 0; j < this.layouts[toLayout].areas[i].length; j++) {
                        const c = this.layouts[toLayout].areas[i][j];
                        if (c === toCell) {
                            this.layouts[toLayout].areas[i][j] = fromCell;
                        }
                    }
                }
                for (let i = 0; i < this.layouts[fromLayout].areas.length; i++) {
                    for (let j = 0; j < this.layouts[fromLayout].areas[i].length; j++) {
                        const c = this.layouts[fromLayout].areas[i][j];
                        if (c === fromCell) {
                            this.layouts[fromLayout].areas[i][j] = toCell;
                        }
                    }
                }
            }
            this.requestUpdate();
        }
        static resetAll() {
            Object.keys(Element_1.ELEMENTS).forEach((k) => Element_1.ELEMENTS[k].reset());
            PERSIST.clearCache();
        }
        connectedCallback() {
            super.connectedCallback();
            Element_1.ELEMENTS[this.page.id] = this;
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            delete Element_1.ELEMENTS[this.page.id];
        }
    };
    // GLOBAL
    // -------------------------
    Element.ELEMENTS = {};
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ attribute: false })
    ], Element.prototype, "page", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ attribute: false })
    ], Element.prototype, "pageJson", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ attribute: false })
    ], Element.prototype, "dataProvider", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ attribute: false })
    ], Element.prototype, "visibilityCheck", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean })
    ], Element.prototype, "edit", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String })
    ], Element.prototype, "width", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String })
    ], Element.prototype, "height", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "isError", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "drag", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "dragOver", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.query)(".container")
    ], Element.prototype, "elContainer", void 0);
    __decorate([
        _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_2__.Decorator.Evt()
    ], Element.prototype, "error", void 0);
    __decorate([
        _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_2__.Decorator.Evt()
    ], Element.prototype, "widgetError", void 0);
    __decorate([
        _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_2__.Decorator.Evt()
    ], Element.prototype, "widgetStatus", void 0);
    Element = Element_1 = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.customElement)("uuip-dynamic-widgets")
    ], Element);
    DynamicLayout.Element = Element;
})(DynamicLayout || (DynamicLayout = {}));


/***/ }),

/***/ "./src/widgets/DynamicWidget.scss":
/*!****************************************!*\
  !*** ./src/widgets/DynamicWidget.scss ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host([edit]) agentx-wc-widget-wrapper::part(widget-section) {
  opacity: 0.3;
}
/*# sourceURL=/home/jenkins/agent/workspace/cicd-jobs/wxcc-common-CI-Builder/packages/@uuip/unified-ui-platform/src/widgets/DynamicWidget.scss */
/*# sourceURL=DynamicWidget.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL2plbmtpbnMvYWdlbnQvd29ya3NwYWNlL2NpY2Qtam9icy93eGNjLWNvbW1vbi1DSS1CdWlsZGVyL3BhY2thZ2VzL0B1dWlwL3VuaWZpZWQtdWktcGxhdGZvcm0vc3JjL3dpZGdldHMvRHluYW1pY1dpZGdldC5zY3NzIiwiRHluYW1pY1dpZGdldC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUNFO0VBQ0UsWUFBQTtBQ0FKIiwiZmlsZSI6IkR5bmFtaWNXaWRnZXQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIjpob3N0KFtlZGl0XSkge1xuICBhZ2VudHgtd2Mtd2lkZ2V0LXdyYXBwZXI6OnBhcnQod2lkZ2V0LXNlY3Rpb24pIHtcbiAgICBvcGFjaXR5OiAwLjM7XG4gIH1cbn1cbiIsIjpob3N0KFtlZGl0XSkgYWdlbnR4LXdjLXdpZGdldC13cmFwcGVyOjpwYXJ0KHdpZGdldC1zZWN0aW9uKSB7XG4gIG9wYWNpdHk6IDAuMztcbn0iXX0= */`);
    

/***/ }),

/***/ "./src/widgets/DynamicWidget.ts":
/*!**************************************!*\
  !*** ./src/widgets/DynamicWidget.ts ***!
  \**************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   DynamicWidget: () => (/* binding */ DynamicWidget)
/* harmony export */ });
/* harmony import */ var _widgets_src_validate__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/widgets/src/validate */ "./src/widgets/src/validate/index.ts");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @uuip/unified-ui-platform-sdk */ "@uuip/unified-ui-platform-sdk");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var loadjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! loadjs */ "loadjs");
/* harmony import */ var loadjs__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(loadjs__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _DynamicWidget_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./DynamicWidget.scss */ "./src/widgets/DynamicWidget.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable @typescript-eslint/no-explicit-any */






const VALIDATE = new _widgets_src_validate__WEBPACK_IMPORTED_MODULE_0__.DynamicWidgetsValidate();
const SCRIPTS = {};
var DynamicWidget;
(function (DynamicWidget) {
    /**
     * @element uuip-dynamic-widget
     * @fires widgetStatus
     * @fires widgetError
     */
    let Element = class Element extends lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement {
        constructor() {
            super(...arguments);
            this.edit = false;
            this.element = null;
            this.isError = true;
        }
        static get styles() {
            return _DynamicWidget_scss__WEBPACK_IMPORTED_MODULE_5__["default"];
        }
        updated(p) {
            const _super = Object.create(null, {
                updated: { get: () => super.updated }
            });
            return __awaiter(this, void 0, void 0, function* () {
                _super.updated.call(this, p);
                if (p.has("options") || p.has("visibilityCheck") || p.has("dataProvider")) {
                    this.disposeRootComp();
                    const check = VALIDATE.options(this.options, this.optionsJson);
                    this.isError = check.isError;
                    if (check.isError) {
                        this.element = null;
                        this.widgetError.emit({
                            isValidationError: true,
                            options: this.options,
                            messages: check.messages,
                            json: check.json
                        });
                        return;
                    }
                    else {
                        this.COMP_ROOT = this.createComp({
                            opt: this.options,
                            isVisible: true,
                            elem: null,
                            parent: null,
                            children: [],
                            childIndex: 0,
                            disposes: {
                                self: [],
                                childrenVisibility: []
                            }
                        });
                        this.createCompSlots(this.COMP_ROOT);
                        this.createCompElem(this.COMP_ROOT);
                    }
                }
            });
        }
        render() {
            if (this.isError) {
                return lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing;
            }
            return this.element ? this.element : lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing;
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            this.disposeRootComp();
        }
        // --------------------------
        createComp(COMP) {
            // VISIBILITY check (only works on children)
            if (COMP.parent) {
                const isVisibility = this.visibilityCheck && typeof COMP.opt.visibility == "string" && COMP.opt.visibility.trim();
                if (isVisibility) {
                    const upd = (visible) => {
                        // show
                        if (visible && !COMP.isVisible) {
                            this.createComp(COMP);
                            this.createCompSlots(COMP);
                            this.createCompElem(COMP);
                        }
                        // hide
                        if (!visible && COMP.isVisible) {
                            this.disposeComp(COMP);
                            if (COMP.parent.elem) {
                                COMP.parent.elem.removeChild(COMP.elem);
                            }
                            COMP.elem = null;
                            COMP.children = [];
                            COMP.isVisible = false;
                            COMP.disposes = {
                                self: [],
                                childrenVisibility: []
                            };
                        }
                    };
                    // unsubscribe if needed
                    const cVis = COMP.parent.disposes.childrenVisibility;
                    if (cVis[COMP.childIndex]) {
                        cVis[COMP.childIndex]();
                    }
                    // subscribe
                    const { visible, dispose } = this.visibilityCheck(COMP.opt.visibility, upd);
                    if (dispose) {
                        cVis[COMP.childIndex] = dispose;
                    }
                    COMP.isVisible = visible;
                }
            }
            // if invisible do not create children
            if (!COMP.isVisible) {
                return COMP;
            }
            if (COMP.opt.children) {
                COMP.opt.children.forEach((childOpt, i) => {
                    const childComp = {
                        opt: childOpt,
                        isVisible: true,
                        elem: null,
                        parent: COMP,
                        children: [],
                        childIndex: i,
                        disposes: {
                            self: [],
                            childrenVisibility: []
                        }
                    };
                    COMP.children[i] = childComp;
                    this.createComp(childComp); // RECURSION
                });
            }
            return COMP;
        }
        // eslint-disable-next-line sonarjs/cognitive-complexity
        createCompElem(COMP) {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                if (!COMP.isVisible) {
                    return;
                }
                const { comp, attributes, properties, style, textContent, wrapper } = COMP.opt;
                if ((_a = COMP.opt.script) === null || _a === void 0 ? void 0 : _a.trim()) {
                    try {
                        yield this.loadScript(COMP.opt);
                        // eslint-disable-next-line sonarjs/no-ignored-exceptions
                    }
                    catch (err) {
                        return;
                    }
                }
                COMP.elem = document.createElement(comp);
                const isDataMustBeProvided = (s) => s[0] === "$";
                if (attributes) {
                    for (const k in attributes) {
                        const v = attributes[k];
                        if (this.dataProvider && isDataMustBeProvided(v)) {
                            const cloneK = `${k}`;
                            const cloneElem = COMP.elem;
                            const upd = (valueToUpdate) => cloneElem.setAttribute(cloneK, valueToUpdate);
                            const { value, dispose } = this.dataProvider(v, upd);
                            if (dispose) {
                                COMP.disposes.self.push(dispose);
                            }
                            COMP.elem.setAttribute(k, value);
                        }
                        else {
                            COMP.elem.setAttribute(k, v);
                        }
                    }
                }
                if (properties) {
                    for (const k in properties) {
                        const v = properties[k];
                        if (this.dataProvider && isDataMustBeProvided(v)) {
                            const cloneK = `${k}`;
                            const cloneElem = COMP.elem;
                            const upd = (valueToUpdate) => (cloneElem[cloneK] = valueToUpdate);
                            const { value, dispose } = this.dataProvider(v, upd);
                            if (dispose) {
                                COMP.disposes.self.push(dispose);
                            }
                            COMP.elem[k] = value;
                        }
                        else {
                            COMP.elem[k] = v;
                        }
                    }
                }
                if (textContent) {
                    if (this.dataProvider && isDataMustBeProvided(textContent)) {
                        const upd = (v) => (COMP.elem.textContent = v);
                        const { value, dispose } = this.dataProvider(textContent, upd);
                        if (dispose) {
                            COMP.disposes.self.push(dispose);
                        }
                        COMP.elem.textContent = value;
                    }
                    else {
                        COMP.elem.textContent = textContent;
                    }
                }
                if (style) {
                    for (const k in style) {
                        COMP.elem.style[k] = style[k];
                    }
                }
                // ROST REMOVE: "uuip-wc-widget-wrapper" should be removed from here
                // AgentX functionality should be removed from UUIP
                // ------------------------------------------------
                if (wrapper) {
                    const elemWrapper = document.createElement("uuip-wc-widget-wrapper");
                    let title = wrapper.title;
                    if (this.dataProvider && isDataMustBeProvided(title)) {
                        const upd = (v) => elemWrapper.setAttribute("title", v);
                        const { value, dispose } = this.dataProvider(wrapper.title, upd);
                        if (dispose) {
                            COMP.disposes.self.push(dispose);
                        }
                        title = value;
                    }
                    elemWrapper.setAttribute("title", title);
                    if (wrapper.id) {
                        elemWrapper.setAttribute("id", wrapper.id);
                    }
                    let maximizeAreaName = wrapper.maximizeAreaName;
                    if (this.dataProvider && isDataMustBeProvided(maximizeAreaName)) {
                        const upd = (v) => elemWrapper.setAttribute("maximizeToAreaName", v);
                        const { value, dispose } = this.dataProvider(wrapper.maximizeAreaName, upd);
                        if (dispose) {
                            COMP.disposes.self.push(dispose);
                        }
                        maximizeAreaName = value;
                    }
                    elemWrapper.setAttribute("maximizeToAreaName", maximizeAreaName);
                    elemWrapper.appendChild(COMP.elem);
                    COMP.elem = elemWrapper;
                }
                // ------------------------------------------------
                // INSERT elemet by json order
                if (COMP.parent == null) {
                    this.element = COMP.elem;
                }
                else {
                    if (COMP.parent.elem == null) {
                        // eslint-disable-next-line no-console
                        console.warn("Trying to insert insertElem. But COMP.parent.elem == null");
                        return;
                    }
                    let beforeElem = null;
                    for (let i = COMP.childIndex + 1; i < COMP.parent.children.length; i++) {
                        const component = COMP.parent.children[i];
                        if (component && component.isVisible && component.elem != null) {
                            beforeElem = component.elem;
                            break;
                        }
                    }
                    if (beforeElem) {
                        COMP.parent.elem.insertBefore(COMP.elem, beforeElem);
                    }
                    else {
                        COMP.parent.elem.appendChild(COMP.elem);
                    }
                }
                // ------
                COMP.children.forEach((c) => this.createCompElem(c)); // RECURSION
            });
        }
        createCompSlots(COMP) {
            const isSlot = COMP.opt.comp === "slot";
            if (isSlot) {
                const slotName = COMP.opt.attributes.name;
                const isSlotContentExists = this.querySelectorAll(`[slot="${slotName}"]`).length > 0;
                if (!isSlotContentExists) {
                    const slotChain = document.createElement("slot");
                    slotChain.setAttribute("name", slotName);
                    slotChain.setAttribute("slot", slotName);
                    slotChain.setAttribute("dw-generated", "true");
                    this.appendChild(slotChain);
                }
            }
            COMP.children.forEach((c) => this.createCompSlots(c)); // RECURSION
        }
        disposeCompSlots(COMP) {
            const isSlot = COMP.opt.comp === "slot";
            if (isSlot) {
                const slotName = COMP.opt.attributes.name;
                const slots = this.querySelectorAll(`[slot="${slotName}"]`);
                const isSlotContentExists = slots.length > 0;
                if (isSlotContentExists) {
                    slots.forEach((s) => {
                        if (s.getAttribute("dw-generated")) {
                            this.removeChild(s);
                        }
                    });
                }
            }
            COMP.children.forEach((c) => this.createCompSlots(c)); // RECURSION
        }
        loadScript(opt) {
            return new Promise((resolve, reject) => {
                const url = opt.script.trim();
                const emit = (status) => this.widgetStatus.emit({ options: opt, status });
                const emitErr = () => this.widgetStatus.emit({
                    options: opt,
                    status: "error",
                    errorMessage: `Can't load script: ${url}`
                });
                const emitRegErr = () => this.widgetStatus.emit({
                    options: opt,
                    status: "errorRegister",
                    errorMessage: `Script '${opt.script}' loaded but '${opt.comp}' component not registered`
                });
                if (SCRIPTS[url] === "loading") {
                    emit("loading");
                    loadjs__WEBPACK_IMPORTED_MODULE_4___default().ready(url, () => {
                        if (window.customElements.get(opt.comp)) {
                            emit("loaded");
                            resolve(true);
                        }
                    });
                }
                else if (SCRIPTS[url] === "loaded") {
                    emit("loaded");
                    resolve(true);
                }
                else if (SCRIPTS[url] === "error") {
                    emitErr();
                    reject();
                }
                else if (SCRIPTS[url] === "errorRegister") {
                    emitRegErr();
                    reject();
                }
                else {
                    emit("loading");
                    SCRIPTS[url] = "loading";
                    loadjs__WEBPACK_IMPORTED_MODULE_4___default()([url], url, { returnPromise: true })
                        .then(() => {
                        if (window.customElements.get(opt.comp)) {
                            emit("loaded");
                            SCRIPTS[url] = "loaded";
                            resolve(true);
                        }
                        else {
                            emitRegErr();
                            SCRIPTS[url] = "errorRegister";
                            reject();
                        }
                    })
                        .catch(() => {
                        emitErr();
                        SCRIPTS[url] = "error";
                        reject();
                    });
                }
            });
        }
        disposeRootComp() {
            if (this.COMP_ROOT) {
                this.disposeComp(this.COMP_ROOT);
                this.COMP_ROOT = undefined;
            }
        }
        disposeComp(COMP) {
            this.disposeCompSlots(COMP);
            COMP.disposes.self.forEach((dispose) => dispose());
            COMP.disposes.childrenVisibility.forEach((dispose) => dispose());
            COMP.children.forEach((child) => this.disposeComp(child));
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ attribute: false })
    ], Element.prototype, "options", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ attribute: false })
    ], Element.prototype, "optionsJson", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ attribute: false })
    ], Element.prototype, "dataProvider", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ attribute: false })
    ], Element.prototype, "visibilityCheck", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
    ], Element.prototype, "edit", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
    ], Element.prototype, "element", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
    ], Element.prototype, "isError", void 0);
    __decorate([
        _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_1__.Decorator.Evt()
    ], Element.prototype, "widgetError", void 0);
    __decorate([
        _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_1__.Decorator.Evt()
    ], Element.prototype, "widgetStatus", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("uuip-dynamic-widget")
    ], Element);
    DynamicWidget.Element = Element;
})(DynamicWidget || (DynamicWidget = {}));


/***/ }),

/***/ "./src/widgets/src/validate/index.ts":
/*!*******************************************!*\
  !*** ./src/widgets/src/validate/index.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   DynamicWidgetsValidate: () => (/* binding */ DynamicWidgetsValidate)
/* harmony export */ });
/* harmony import */ var json_source_map__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! json-source-map */ "json-source-map");
/* harmony import */ var json_source_map__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(json_source_map__WEBPACK_IMPORTED_MODULE_0__);
/* eslint-disable @typescript-eslint/no-explicit-any */

class DynamicWidgetsValidate {
    constructor() {
        // ----------
        this.isJsonStringifyed = true;
        this.json = "";
        this.jsonPrefix = "";
        this.jsonMap = {};
        this.ERRORS = [];
        this.SLOTS = new Map();
    }
    //
    page(v, json, jsonPrefix, reMap = true) {
        this.init(v, json, jsonPrefix, reMap);
        if (v.id !== undefined) {
            if (this.notString(v.id)) {
                this.ERR("property 'id' is must be string", "id");
            }
        }
        else {
            this.ERR("property 'id' is REQUIRED");
        }
        let widgetNames = [];
        if (v.widgets !== undefined) {
            if (this.isObj(v.widgets)) {
                widgetNames = Object.keys(v.widgets);
                if (widgetNames.length > 0) {
                    widgetNames.forEach((k) => this.optionsValidate(v.widgets[k], `widgets.${k}`, true));
                }
                else {
                    this.ERR("property 'widgets' is empty", "widgets");
                }
            }
            else {
                this.ERR("property 'widgets' must be Record<string, DynamicWidget.Options>", "widgets");
            }
        }
        else {
            this.ERR("property 'widgets' is REQUIRED");
        }
        this.checkSlots();
        if (v.layout !== undefined) {
            if (this.isObj(v.layout)) {
                if (Object.keys(v.layout).length > 0) {
                    const layoutNames = Object.keys(v.layout);
                    if ("ROOT" in v.layout) {
                        const layout = v.layout;
                        Object.keys(layout).forEach((k) => {
                            if (this.isObj(layout[k])) {
                                this.layoutValidate(layout[k], widgetNames, layoutNames, k);
                            }
                            else {
                                this.ERR(`property 'layout[${k}]' must be - { areas: string[][]; size: { rows: number[]; cols: number[] } }`, `layout.${k}`);
                            }
                        });
                    }
                    else {
                        this.layoutValidate(v.layout, widgetNames, layoutNames);
                    }
                }
                else {
                    this.ERR("property 'layout' is empty", "layout");
                }
            }
            else {
                this.ERR("property 'layout' must be - { areas: string[][]; size: { rows: number[]; cols: number[] } }", "layout");
            }
        }
        else {
            this.ERR("property 'layout' is REQUIRED");
        }
        this.getUnknownKeys(v, ["id", "widgets", "layout"]).map((k) => this.ERR(`unknown key - '${k}'`, k));
        if (this.ERRORS.length > 0) {
            const result = {
                isError: true,
                messages: this.ERRORS
            };
            if (this.isJsonStringifyed) {
                result.json = this.json;
            }
            return result;
        }
        else {
            return { isError: false };
        }
    }
    options(v, json, jsonPrefix, reMap = true) {
        this.init(v, json, jsonPrefix, reMap);
        this.optionsValidate(v, "", true);
        this.checkSlots();
        if (this.ERRORS.length > 0) {
            const result = {
                isError: true,
                messages: this.ERRORS
            };
            if (this.isJsonStringifyed) {
                result.json = this.json;
            }
            return result;
        }
        else {
            return { isError: false };
        }
    }
    // -------------------
    // eslint-disable-next-line sonarjs/cognitive-complexity
    layoutValidate(layout, widgetNames, layoutNames, path = "") {
        const err = (msg, subPath = "") => {
            this.ERR(msg, (path ? `layout.${path}` : "layout") + (subPath ? `.${subPath}` : ""));
        };
        const layoutName = path ? `layout[${path}]` : "layout";
        this.getUnknownKeys(layout, ["areas", "size"]).map((k) => err(`unknown key in '${layoutName}' property - '${k}'`, k));
        let rows = 0;
        let cols = 0;
        if (layout.size !== undefined) {
            if (this.isObj(layout.size)) {
                this.getUnknownKeys(layout.size, ["rows", "cols"]).map((k) => err(`unknown key in '${layoutName}.size' property - '${k}'`, `size.${k}`));
                if (layout.size.rows !== undefined) {
                    if (Array.isArray(layout.size.rows)) {
                        rows = layout.size.rows.length;
                        if (rows > 0) {
                            layout.size.rows.forEach((size) => {
                                if (size <= 0) {
                                    err(`property '${layoutName}.size.rows' must be >= 0 but we have (${size})`, "size.rows");
                                }
                            });
                        }
                        else {
                            err(`property '${layoutName}.size.rows' is empty`, "size.rows");
                        }
                    }
                    else {
                        err(`property '${layoutName}.size.rows' must be Array of numbers`, "size.rows");
                    }
                }
                else {
                    err(`property '${layoutName}.size.rows' is REQUIRED`, "size");
                }
                if (layout.size.cols !== undefined) {
                    if (Array.isArray(layout.size.rows)) {
                        cols = layout.size.cols.length;
                        if (cols > 0) {
                            layout.size.cols.forEach((size) => {
                                if (size <= 0) {
                                    err(`property '${layoutName}.size.cols' must be >= 0 but we have (${size})`, "size.cols");
                                }
                            });
                        }
                        else {
                            err(`property '${layoutName}.size.cols' is empty`, "size.cols");
                        }
                    }
                    else {
                        err(`property '${layoutName}.size.cols' must be Array of numbers`, "size.cols");
                    }
                }
                else {
                    err(`property '${layoutName}.size.cols' is REQUIRED`, "size");
                }
            }
            else {
                err(`property '${layoutName}.size' must be - { rows: number[]; cols: number[] }`, "size");
            }
        }
        else {
            err(`property '${layoutName}.size' is REQUIRED`);
        }
        if (layout.areas !== undefined) {
            if (Array.isArray(layout.areas)) {
                const len = layout.areas.length;
                if (len > 0) {
                    if (len !== rows) {
                        err(`property '${layoutName}.areas.length' (${len}) != '${layoutName}.size.rows.length' (${rows})`, "areas");
                    }
                    layout.areas.forEach((x, i) => {
                        if (x.length !== cols) {
                            err(`property '${layoutName}.areas[${i}].length' (${x.length}) != '${layoutName}.size.cols.length' (${cols})`, "areas");
                        }
                    });
                    layout.areas.forEach((w) => {
                        w.forEach((widgetName) => {
                            if (!widgetNames.includes(widgetName) && !layoutNames.includes(widgetName)) {
                                err(`property '${layoutName}.areas' - unable to find '${widgetName}' in widgets`, "areas");
                            }
                        });
                    });
                }
                else {
                    err(`property '${layoutName}.areas' is empty`, "areas");
                }
            }
            else {
                err(`property '${layoutName}.areas' must be string[][]`, "areas");
            }
        }
        else {
            err(`property '${layoutName}.areas' is REQUIRED`);
        }
    }
    // eslint-disable-next-line sonarjs/cognitive-complexity
    optionsValidate(v, path = "", isRoot = false) {
        var _a;
        const err = (msg, subPath = "") => {
            const msgFormat = path ? `${path}: ${msg}` : msg;
            const pathFormat = path ? path + (subPath ? `.${subPath}` : "") : (subPath !== null && subPath !== void 0 ? subPath : "");
            this.ERR(msgFormat, pathFormat);
        };
        if (v.comp !== undefined) {
            if (this.notString(v.comp)) {
                err("property 'comp' must be string", "comp");
            }
        }
        else {
            err("property 'comp' is REQUIRED");
        }
        if (v.script && this.notString(v.script)) {
            err("property 'script' must be string", "script");
        }
        if (v.textContent && this.notString(v.textContent)) {
            err("property 'textContent' must be string", "textContent");
        }
        if (v.visibility && this.notString(v.visibility)) {
            err("property 'visibility' must be string", "visibility");
        }
        if (isRoot && v.visibility) {
            err("property 'visibility' is not working on Dynamic Widget ROOT element", "visibility");
        }
        if (v.properties !== undefined) {
            if (this.isObj(v.properties)) {
                if (Object.keys(v.properties).length < 1) {
                    err("property 'properties' is empty", "properties");
                }
            }
            else {
                err("property 'properties' must be Record<string, any>", "properties");
            }
        }
        if (v.attributes !== undefined) {
            if (this.isObj(v.attributes)) {
                if (Object.keys(v.attributes).length < 1) {
                    err("property 'attributes' is empty", "attributes");
                }
            }
            else {
                err("property 'attributes' must be Record<string, any>", "attributes");
            }
        }
        if (v.wrapper !== undefined) {
            if (this.isObj(v.wrapper)) {
                this.getUnknownKeys(v.wrapper, ["title", "id", "maximizeAreaName"]).map((k) => err(`unknown key in 'wrapper' property - '${k}'`, `wrapper.${k}`));
                if (v.wrapper.id !== undefined) {
                    if (this.notString(v.wrapper.id)) {
                        err("property 'wrapper.id' must be string", "wrapper.id");
                    }
                }
                if (v.wrapper.title !== undefined) {
                    if (this.notString(v.wrapper.title)) {
                        err("property 'wrapper.title' must be string", "wrapper.title");
                    }
                }
                else {
                    err("property 'wrapper.title' is REQUIRED", "wrapper");
                }
                if (v.wrapper.maximizeAreaName !== undefined) {
                    if (this.notString(v.wrapper.maximizeAreaName)) {
                        err("property 'wrapper.maximizeAreaName' must be string", "wrapper.maximizeAreaName");
                    }
                }
                else {
                    err("property 'wrapper.maximizeAreaName' is REQUIRED", "wrapper");
                }
            }
            else {
                err("property 'wrapper' must be { title: string; maximizeAreaName: string }", "wrapper");
            }
        }
        if (v.responsive !== undefined) {
            if (typeof v.responsive !== "boolean") {
                err("property 'responsive' must be bool", "responsive");
            }
        }
        if (v.style !== undefined) {
            if (this.isObj(v.style)) {
                // TODO - develop CSSStyleDeclaration keys validation method
            }
            else {
                err("property 'style' must be Partial<CSSStyleDeclaration>", "style");
            }
        }
        this.getUnknownKeys(v, [
            "comp",
            "script",
            "properties",
            "attributes",
            "children",
            "textContent",
            "style",
            "visibility",
            "responsive",
            "wrapper"
        ]).map((k) => err(`unknown key - '${k}'`, k));
        if (v.children !== undefined) {
            if (Array.isArray(v.children)) {
                if (v.children.length < 1) {
                    err("property 'children' is empty", "children");
                }
                // RECURSION
                if (v.children) {
                    const len = v.children.length;
                    for (let i = 0; i < len; i++) {
                        this.optionsValidate(v.children[i], path ? `${path}.children.${i}` : `children.${i}`);
                    }
                }
            }
            else {
                err("property 'children' must be Array of {options}", "children");
            }
        }
        const isSlot = v.comp && v.comp.trim() && v.comp.toLowerCase() === "slot";
        if (isSlot) {
            const slotName = (_a = v.attributes) === null || _a === void 0 ? void 0 : _a.name;
            if (slotName) {
                this.SLOTS;
                if (this.SLOTS.has(slotName)) {
                    this.SLOTS.get(slotName).push(path);
                }
                else {
                    this.SLOTS.set(slotName, [path]);
                }
            }
            else {
                err("<slot> element must have 'name' attribute");
            }
        }
    }
    checkSlots() {
        this.SLOTS.forEach((slotPath, slotName) => {
            if (slotPath.length > 1) {
                this.ERR(`<slot name="${slotName}"> declared ${slotPath.length} times.`, slotPath);
            }
        });
    }
    ERR(msg, path) {
        let location = " [line: 1]";
        const getLocation = (subPath) => {
            const p = (this.jsonPrefix ? this.jsonPrefix : "") + (subPath ? `.${subPath}` : "");
            const k = `/${p.split(".").join("/")}`;
            const map = this.jsonMap[k];
            if (map) {
                const loc = "key" in map ? map.key : map.value;
                return ` [line: ${loc.line + 1}]`;
            }
            else {
                return "";
            }
        };
        if (typeof path == "string" && path.trim()) {
            location = getLocation(path);
        }
        else if (Array.isArray(path)) {
            location =
                ` [${path
                    .map((l) => getLocation(l))
                    .filter((x) => x !== "")
                    .join(",")} ]`;
        }
        else if (this.jsonPrefix) {
            location = getLocation("");
        }
        this.ERRORS.push(msg + location);
    }
    init(obj, json, jsonPrefix, reMap = true) {
        this.isJsonStringifyed = json ? false : true;
        this.json = this.isJsonStringifyed ? JSON.stringify(obj, null, 2) : json;
        this.jsonPrefix = jsonPrefix !== null && jsonPrefix !== void 0 ? jsonPrefix : "";
        if (reMap) {
            this.jsonMap = json_source_map__WEBPACK_IMPORTED_MODULE_0___default().parse(this.json).pointers;
        }
        this.ERRORS = [];
        this.SLOTS = new Map();
    }
    notString(v) {
        return typeof v !== "string" || !v.trim();
    }
    isObj(v) {
        return typeof v === "object" && !Array.isArray(v);
    }
    getUnknownKeys(v, keysValid) {
        const keysUnknown = [];
        Object.keys(v).forEach((k) => {
            if (keysValid.indexOf(k) === -1) {
                keysUnknown.push(k);
            }
        });
        return keysUnknown;
    }
}


/***/ }),

/***/ "./src/widgets/src/validate/persist.ts":
/*!*********************************************!*\
  !*** ./src/widgets/src/validate/persist.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   DynamicWidgetsPersist: () => (/* binding */ DynamicWidgetsPersist)
/* harmony export */ });
const KEY = "uuip-dynamic-widgets-pages-layout";
class DynamicWidgetsPersist {
    constructor() {
        const item = localStorage.getItem(KEY);
        this.cache = item ? JSON.parse(item) : {};
    }
    load(page) {
        let layouts = {};
        let isChanged = false;
        const pageLayouts = "ROOT" in page.layout ? page.layout : { ROOT: page.layout };
        const cacheLayouts = this.cache[page.id];
        if (cacheLayouts) {
            layouts = this.iterateLayouts(pageLayouts, (layout, k) => {
                const cache = cacheLayouts[k];
                if (cache && cache.hash === this.createHash(layout)) {
                    return cache.layout;
                }
                else {
                    isChanged = true;
                    return layout;
                }
            });
        }
        else {
            isChanged = true;
            layouts = pageLayouts;
        }
        if (isChanged) {
            this.save(page, layouts);
        }
        return this.clone(layouts);
    }
    save(page, layouts) {
        const pageLayouts = "ROOT" in page.layout ? page.layout : { ROOT: page.layout };
        this.cache[page.id] = this.iterateLayouts(layouts, (layout, k) => {
            return {
                hash: this.createHash(pageLayouts[k]),
                layout: this.clone(layout)
            };
        });
        localStorage.setItem(KEY, JSON.stringify(this.cache));
    }
    reset(page) {
        delete this.cache[page.id];
        localStorage.setItem(KEY, JSON.stringify(this.cache));
        return this.load(page);
    }
    clearCache() {
        localStorage.removeItem(KEY);
        this.cache = {};
    }
    // -----------
    iterateLayouts(layouts, cb) {
        return Object.keys(layouts).reduce((acc, k) => {
            acc[k] = cb(layouts[k], k);
            return acc;
        }, {});
    }
    createHash(layout) {
        const areas = layout.areas.map((p) => p.join("")).join("");
        const size = layout.size ? `${layout.size.cols}_${layout.size.rows}` : "";
        const hash = `rows:${layout.areas.length}_cols:${layout.areas[0].length}_${areas}_${size}`;
        return hash;
    }
    clone(obj) {
        return JSON.parse(JSON.stringify(obj));
    }
}


/***/ }),

/***/ "@uuip/unified-ui-platform-sdk":
/*!************************************************!*\
  !*** external "@uuip/unified-ui-platform-sdk" ***!
  \************************************************/
/***/ ((module) => {

"use strict";
module.exports = require("@uuip/unified-ui-platform-sdk");

/***/ }),

/***/ "axios":
/*!************************!*\
  !*** external "axios" ***!
  \************************/
/***/ ((module) => {

"use strict";
module.exports = require("axios");

/***/ }),

/***/ "event-emitter":
/*!********************************!*\
  !*** external "event-emitter" ***!
  \********************************/
/***/ ((module) => {

"use strict";
module.exports = require("event-emitter");

/***/ }),

/***/ "event-emitter/all-off":
/*!****************************************!*\
  !*** external "event-emitter/all-off" ***!
  \****************************************/
/***/ ((module) => {

"use strict";
module.exports = require("event-emitter/all-off");

/***/ }),

/***/ "json-source-map":
/*!**********************************!*\
  !*** external "json-source-map" ***!
  \**********************************/
/***/ ((module) => {

"use strict";
module.exports = require("json-source-map");

/***/ }),

/***/ "lit-element":
/*!******************************!*\
  !*** external "lit-element" ***!
  \******************************/
/***/ ((module) => {

"use strict";
module.exports = require("lit-element");

/***/ }),

/***/ "lit-html":
/*!***************************!*\
  !*** external "lit-html" ***!
  \***************************/
/***/ ((module) => {

"use strict";
module.exports = require("lit-html");

/***/ }),

/***/ "lit-html/directives/class-map":
/*!************************************************!*\
  !*** external "lit-html/directives/class-map" ***!
  \************************************************/
/***/ ((module) => {

"use strict";
module.exports = require("lit-html/directives/class-map");

/***/ }),

/***/ "lit-html/directives/repeat":
/*!*********************************************!*\
  !*** external "lit-html/directives/repeat" ***!
  \*********************************************/
/***/ ((module) => {

"use strict";
module.exports = require("lit-html/directives/repeat");

/***/ }),

/***/ "lit-html/directives/style-map":
/*!************************************************!*\
  !*** external "lit-html/directives/style-map" ***!
  \************************************************/
/***/ ((module) => {

"use strict";
module.exports = require("lit-html/directives/style-map");

/***/ }),

/***/ "loadjs":
/*!*************************!*\
  !*** external "loadjs" ***!
  \*************************/
/***/ ((module) => {

"use strict";
module.exports = require("loadjs");

/***/ }),

/***/ "nanoid":
/*!*************************!*\
  !*** external "nanoid" ***!
  \*************************/
/***/ ((module) => {

"use strict";
module.exports = require("nanoid");

/***/ }),

/***/ "node-html-parser":
/*!***********************************!*\
  !*** external "node-html-parser" ***!
  \***********************************/
/***/ ((module) => {

"use strict";
module.exports = require("node-html-parser");

/***/ }),

/***/ "node-html-parser/dist/nodes/type":
/*!***************************************************!*\
  !*** external "node-html-parser/dist/nodes/type" ***!
  \***************************************************/
/***/ ((module) => {

"use strict";
module.exports = require("node-html-parser/dist/nodes/type");

/***/ }),

/***/ "page":
/*!***********************!*\
  !*** external "page" ***!
  \***********************/
/***/ ((module) => {

"use strict";
module.exports = require("page");

/***/ }),

/***/ "path-to-regexp":
/*!*********************************!*\
  !*** external "path-to-regexp" ***!
  \*********************************/
/***/ ((module) => {

"use strict";
module.exports = require("path-to-regexp");

/***/ }),

/***/ "qs":
/*!*********************!*\
  !*** external "qs" ***!
  \*********************/
/***/ ((module) => {

"use strict";
module.exports = require("qs");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
/*!**********************!*\
  !*** ./src/index.ts ***!
  \**********************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CI: () => (/* reexport safe */ _identity_identity__WEBPACK_IMPORTED_MODULE_1__.CI),
/* harmony export */   DynamicLayout: () => (/* reexport safe */ _widgets_DynamicLayout__WEBPACK_IMPORTED_MODULE_3__.DynamicLayout),
/* harmony export */   DynamicWidget: () => (/* reexport safe */ _widgets_DynamicWidget__WEBPACK_IMPORTED_MODULE_4__.DynamicWidget),
/* harmony export */   OAuth: () => (/* reexport safe */ _auth_auth__WEBPACK_IMPORTED_MODULE_0__.OAuth),
/* harmony export */   Router: () => (/* reexport safe */ _router__WEBPACK_IMPORTED_MODULE_2__.Router)
/* harmony export */ });
/* harmony import */ var _auth_auth__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./auth/auth */ "./src/auth/auth.ts");
/* harmony import */ var _identity_identity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./identity/identity */ "./src/identity/identity.ts");
/* harmony import */ var _router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./router */ "./src/router/index.ts");
/* harmony import */ var _widgets_DynamicLayout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./widgets/DynamicLayout */ "./src/widgets/DynamicLayout.ts");
/* harmony import */ var _widgets_DynamicWidget__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./widgets/DynamicWidget */ "./src/widgets/DynamicWidget.ts");





//

})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=index.js.map